/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as SignImport } from "./routes/sign";
import { Route as ResetPasswordImport } from "./routes/reset-password";
import { Route as RegisterImport } from "./routes/register";
import { Route as LoginImport } from "./routes/login";
import { Route as ForgotPasswordImport } from "./routes/forgot-password";
import { Route as FileShareImport } from "./routes/file-share";
import { Route as ChangePasswordImport } from "./routes/change-password";
import { Route as AuthImport } from "./routes/_auth";
import { Route as OnboardingIndexImport } from "./routes/onboarding/index";
import { Route as AuthIndexImport } from "./routes/_auth/index";
import { Route as AuthSkillsImport } from "./routes/_auth/skills";
import { Route as AuthSignatureRequestsImport } from "./routes/_auth/signature-requests";
import { Route as AuthSettingsImport } from "./routes/_auth/settings";
import { Route as AuthReportsImport } from "./routes/_auth/reports";
import { Route as AuthMailSortingImport } from "./routes/_auth/mail-sorting";
import { Route as AuthFilesImport } from "./routes/_auth/files";
import { Route as AuthChargesImport } from "./routes/_auth/charges";
import { Route as AuthAutomationsImport } from "./routes/_auth/automations";
import { Route as AuthAiImport } from "./routes/_auth/ai";
import { Route as AuthSettingsIndexImport } from "./routes/_auth/settings/index";
import { Route as AuthReportsIndexImport } from "./routes/_auth/reports/index";
import { Route as AuthReferralsIndexImport } from "./routes/_auth/referrals/index";
import { Route as AuthProfileIndexImport } from "./routes/_auth/profile/index";
import { Route as AuthOpportunitiesIndexImport } from "./routes/_auth/opportunities/index";
import { Route as AuthMattersIndexImport } from "./routes/_auth/matters/index";
import { Route as AuthMassTortsIndexImport } from "./routes/_auth/mass-torts/index";
import { Route as AuthLeadsIndexImport } from "./routes/_auth/leads/index";
import { Route as AuthContactsIndexImport } from "./routes/_auth/contacts/index";
import { Route as AuthAppsIndexImport } from "./routes/_auth/apps/index";
import { Route as AuthSettingsUsersImport } from "./routes/_auth/settings/users";
import { Route as AuthSettingsTemplatesImport } from "./routes/_auth/settings/templates";
import { Route as AuthSettingsMatterTypesImport } from "./routes/_auth/settings/matter-types";
import { Route as AuthSettingsMatterDefaultsImport } from "./routes/_auth/settings/matter-defaults";
import { Route as AuthSettingsIntakeImport } from "./routes/_auth/settings/intake";
import { Route as AuthSettingsFirmImport } from "./routes/_auth/settings/firm";
import { Route as AuthSettingsFilesImport } from "./routes/_auth/settings/files";
import { Route as AuthSettingsContactImport } from "./routes/_auth/settings/contact";
import { Route as AuthSettingsCommunicationImport } from "./routes/_auth/settings/communication";
import { Route as AuthReportsUserProductivityImport } from "./routes/_auth/reports/user-productivity";
import { Route as AuthReportsSettlementsImport } from "./routes/_auth/reports/settlements";
import { Route as AuthReportsSettlementSummaryImport } from "./routes/_auth/reports/settlement-summary";
import { Route as AuthReportsRoleAssignmentsImport } from "./routes/_auth/reports/role-assignments";
import { Route as AuthReportsRecordRequestsImport } from "./routes/_auth/reports/record-requests";
import { Route as AuthReportsOpenMattersImport } from "./routes/_auth/reports/open-matters";
import { Route as AuthReportsMyApproachingStatutesImport } from "./routes/_auth/reports/my-approaching-statutes";
import { Route as AuthReportsMatterStatusCountImport } from "./routes/_auth/reports/matter-status-count";
import { Route as AuthReportsMatterActivityImport } from "./routes/_auth/reports/matter-activity";
import { Route as AuthReportsDemandsImport } from "./routes/_auth/reports/demands";
import { Route as AuthReportsDemandSummaryImport } from "./routes/_auth/reports/demand-summary";
import { Route as AuthReportsClosedMattersImport } from "./routes/_auth/reports/closed-matters";
import { Route as AuthReportsCaseAssignmentsImport } from "./routes/_auth/reports/case-assignments";
import { Route as AuthReportsAttorneySummaryImport } from "./routes/_auth/reports/attorney-summary";
import { Route as AuthReportsApproachingStatutesImport } from "./routes/_auth/reports/approaching-statutes";
import { Route as AuthReferralsSettingsImport } from "./routes/_auth/referrals/settings";
import { Route as AuthReferralsPartnerFirmsImport } from "./routes/_auth/referrals/partner-firms";
import { Route as AuthReferralsDirectoryProfileImport } from "./routes/_auth/referrals/directory-profile";
import { Route as AuthReferralsDirectoryImport } from "./routes/_auth/referrals/directory";
import { Route as AuthMattersSettingsImport } from "./routes/_auth/matters/settings";
import { Route as AuthMattersMyMattersImport } from "./routes/_auth/matters/my-matters";
import { Route as AuthFirmReferralProfileImport } from "./routes/_auth/firm/referral-profile";
import { Route as AuthFirmPartnerFirmsImport } from "./routes/_auth/firm/partner-firms";
import { Route as AuthFileContentFileContentIdImport } from "./routes/_auth/file-content.$fileContentId";
import { Route as AuthAppsMyAppsImport } from "./routes/_auth/apps/my-apps";
import { Route as AuthAppsAppLibraryImport } from "./routes/_auth/apps/app-library";
import { Route as AuthSettingsIntakeIndexImport } from "./routes/_auth/settings/intake/index";
import { Route as AuthContactsContactIdIndexImport } from "./routes/_auth/contacts/$contactId/index";
import { Route as AuthSettingsIntakeTeamsImport } from "./routes/_auth/settings/intake/teams";
import { Route as AuthSettingsIntakeTaskPlansImport } from "./routes/_auth/settings/intake/task-plans";
import { Route as AuthSettingsIntakeTagsImport } from "./routes/_auth/settings/intake/tags";
import { Route as AuthSettingsIntakeStatusesImport } from "./routes/_auth/settings/intake/statuses";
import { Route as AuthSettingsIntakeRolesImport } from "./routes/_auth/settings/intake/roles";
import { Route as AuthSettingsIntakeMatterTypesImport } from "./routes/_auth/settings/intake/matter-types";
import { Route as AuthSettingsIntakeLeadSourcesImport } from "./routes/_auth/settings/intake/lead-sources";
import { Route as AuthReferralsSettingsTeamsImport } from "./routes/_auth/referrals/settings/teams";
import { Route as AuthReferralsSettingsTaskPlansImport } from "./routes/_auth/referrals/settings/task-plans";
import { Route as AuthReferralsSettingsTagsImport } from "./routes/_auth/referrals/settings/tags";
import { Route as AuthReferralsSettingsStatusesImport } from "./routes/_auth/referrals/settings/statuses";
import { Route as AuthReferralsSettingsRolesImport } from "./routes/_auth/referrals/settings/roles";
import { Route as AuthReferralsSettingsProfileImport } from "./routes/_auth/referrals/settings/profile";
import { Route as AuthReferralsSettingsMatterTypesImport } from "./routes/_auth/referrals/settings/matter-types";
import { Route as AuthMattersSettingsTeamsImport } from "./routes/_auth/matters/settings/teams";
import { Route as AuthMattersSettingsTaskPlansImport } from "./routes/_auth/matters/settings/task-plans";
import { Route as AuthMattersSettingsTagsImport } from "./routes/_auth/matters/settings/tags";
import { Route as AuthMattersSettingsStatusesImport } from "./routes/_auth/matters/settings/statuses";
import { Route as AuthMattersSettingsScheduledMessagesImport } from "./routes/_auth/matters/settings/scheduled-messages";
import { Route as AuthMattersSettingsRolesImport } from "./routes/_auth/matters/settings/roles";
import { Route as AuthMattersSettingsPhaseProjectsImport } from "./routes/_auth/matters/settings/phase-projects";
import { Route as AuthMattersSettingsMatterTypesImport } from "./routes/_auth/matters/settings/matter-types";
import { Route as AuthMattersSettingsLitigationPlansImport } from "./routes/_auth/matters/settings/litigation-plans";
import { Route as AuthMattersSettingsIntakeTemplatesImport } from "./routes/_auth/matters/settings/intake-templates";
import { Route as AuthMattersSettingsFilesImport } from "./routes/_auth/matters/settings/files";
import { Route as AuthMattersSettingsCostsImport } from "./routes/_auth/matters/settings/costs";
import { Route as AuthMattersMatterIdLayoutImport } from "./routes/_auth/matters/$matterId/_layout";
import { Route as AuthMassTortsMassTortSearchIdLayoutImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout";
import { Route as AuthMattersMatterIdLayoutIndexImport } from "./routes/_auth/matters/$matterId/_layout/index";
import { Route as AuthMassTortsMassTortSearchIdLayoutIndexImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/index";
import { Route as AuthMattersMatterIdLayoutUpdatesImport } from "./routes/_auth/matters/$matterId/_layout/updates";
import { Route as AuthMattersMatterIdLayoutTasksImport } from "./routes/_auth/matters/$matterId/_layout/tasks";
import { Route as AuthMattersMatterIdLayoutSignatureRequestsImport } from "./routes/_auth/matters/$matterId/_layout/signature-requests";
import { Route as AuthMattersMatterIdLayoutSettlementsImport } from "./routes/_auth/matters/$matterId/_layout/settlements";
import { Route as AuthMattersMatterIdLayoutPropertyDamageImport } from "./routes/_auth/matters/$matterId/_layout/property-damage";
import { Route as AuthMattersMatterIdLayoutNotesImport } from "./routes/_auth/matters/$matterId/_layout/notes";
import { Route as AuthMattersMatterIdLayoutMedicalTreatmentsImport } from "./routes/_auth/matters/$matterId/_layout/medical-treatments";
import { Route as AuthMattersMatterIdLayoutLitigationImport } from "./routes/_auth/matters/$matterId/_layout/litigation";
import { Route as AuthMattersMatterIdLayoutLiensImport } from "./routes/_auth/matters/$matterId/_layout/liens";
import { Route as AuthMattersMatterIdLayoutIncidentDetailsImport } from "./routes/_auth/matters/$matterId/_layout/incident-details";
import { Route as AuthMattersMatterIdLayoutFilesImport } from "./routes/_auth/matters/$matterId/_layout/files";
import { Route as AuthMattersMatterIdLayoutEmailsImport } from "./routes/_auth/matters/$matterId/_layout/emails";
import { Route as AuthMattersMatterIdLayoutCustomFieldsImport } from "./routes/_auth/matters/$matterId/_layout/custom-fields";
import { Route as AuthMattersMatterIdLayoutCostsImport } from "./routes/_auth/matters/$matterId/_layout/costs";
import { Route as AuthMattersMatterIdLayoutChargesImport } from "./routes/_auth/matters/$matterId/_layout/charges";
import { Route as AuthMassTortsMassTortSearchIdLayoutTasksImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/tasks";
import { Route as AuthMassTortsMassTortSearchIdLayoutSurveysImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/surveys";
import { Route as AuthMassTortsMassTortSearchIdLayoutNotesImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/notes";
import { Route as AuthMassTortsMassTortSearchIdLayoutFilesImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/files";
import { Route as AuthMassTortsMassTortSearchIdLayoutFileGenerationImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/file-generation";
import { Route as AuthMassTortsMassTortSearchIdLayoutCustomFieldsImport } from "./routes/_auth/mass-torts/$massTortSearchId/_layout/custom-fields";
import { Route as AuthMattersMatterIdLayoutMatterDetailsTabImport } from "./routes/_auth/matters/$matterId/_layout/matter-details/$tab";

// Create Virtual Routes

const AuthMattersMatterIdImport = createFileRoute("/_auth/matters/$matterId")();
const AuthMassTortsMassTortSearchIdImport = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId",
)();

// Create/Update Routes

const SignRoute = SignImport.update({
  id: "/sign",
  path: "/sign",
  getParentRoute: () => rootRoute,
} as any);

const ResetPasswordRoute = ResetPasswordImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRoute,
} as any);

const RegisterRoute = RegisterImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRoute,
} as any);

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRoute,
} as any);

const FileShareRoute = FileShareImport.update({
  id: "/file-share",
  path: "/file-share",
  getParentRoute: () => rootRoute,
} as any);

const ChangePasswordRoute = ChangePasswordImport.update({
  id: "/change-password",
  path: "/change-password",
  getParentRoute: () => rootRoute,
} as any);

const AuthRoute = AuthImport.update({
  id: "/_auth",
  getParentRoute: () => rootRoute,
} as any);

const OnboardingIndexRoute = OnboardingIndexImport.update({
  id: "/onboarding/",
  path: "/onboarding/",
  getParentRoute: () => rootRoute,
} as any);

const AuthIndexRoute = AuthIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthSkillsRoute = AuthSkillsImport.update({
  id: "/skills",
  path: "/skills",
  getParentRoute: () => AuthRoute,
} as any);

const AuthSignatureRequestsRoute = AuthSignatureRequestsImport.update({
  id: "/signature-requests",
  path: "/signature-requests",
  getParentRoute: () => AuthRoute,
} as any);

const AuthSettingsRoute = AuthSettingsImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthRoute,
} as any);

const AuthReportsRoute = AuthReportsImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMailSortingRoute = AuthMailSortingImport.update({
  id: "/mail-sorting",
  path: "/mail-sorting",
  getParentRoute: () => AuthRoute,
} as any);

const AuthFilesRoute = AuthFilesImport.update({
  id: "/files",
  path: "/files",
  getParentRoute: () => AuthRoute,
} as any);

const AuthChargesRoute = AuthChargesImport.update({
  id: "/charges",
  path: "/charges",
  getParentRoute: () => AuthRoute,
} as any);

const AuthAutomationsRoute = AuthAutomationsImport.update({
  id: "/automations",
  path: "/automations",
  getParentRoute: () => AuthRoute,
} as any);

const AuthAiRoute = AuthAiImport.update({
  id: "/ai",
  path: "/ai",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMattersMatterIdRoute = AuthMattersMatterIdImport.update({
  id: "/matters/$matterId",
  path: "/matters/$matterId",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMassTortsMassTortSearchIdRoute =
  AuthMassTortsMassTortSearchIdImport.update({
    id: "/mass-torts/$massTortSearchId",
    path: "/mass-torts/$massTortSearchId",
    getParentRoute: () => AuthRoute,
  } as any);

const AuthSettingsIndexRoute = AuthSettingsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthReportsIndexRoute = AuthReportsIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReferralsIndexRoute = AuthReferralsIndexImport.update({
  id: "/referrals/",
  path: "/referrals/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthProfileIndexRoute = AuthProfileIndexImport.update({
  id: "/profile/",
  path: "/profile/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthOpportunitiesIndexRoute = AuthOpportunitiesIndexImport.update({
  id: "/opportunities/",
  path: "/opportunities/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMattersIndexRoute = AuthMattersIndexImport.update({
  id: "/matters/",
  path: "/matters/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMassTortsIndexRoute = AuthMassTortsIndexImport.update({
  id: "/mass-torts/",
  path: "/mass-torts/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthLeadsIndexRoute = AuthLeadsIndexImport.update({
  id: "/leads/",
  path: "/leads/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthContactsIndexRoute = AuthContactsIndexImport.update({
  id: "/contacts/",
  path: "/contacts/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthAppsIndexRoute = AuthAppsIndexImport.update({
  id: "/apps/",
  path: "/apps/",
  getParentRoute: () => AuthRoute,
} as any);

const AuthSettingsUsersRoute = AuthSettingsUsersImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsTemplatesRoute = AuthSettingsTemplatesImport.update({
  id: "/templates",
  path: "/templates",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsMatterTypesRoute = AuthSettingsMatterTypesImport.update({
  id: "/matter-types",
  path: "/matter-types",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsMatterDefaultsRoute = AuthSettingsMatterDefaultsImport.update(
  {
    id: "/matter-defaults",
    path: "/matter-defaults",
    getParentRoute: () => AuthSettingsRoute,
  } as any,
);

const AuthSettingsIntakeRoute = AuthSettingsIntakeImport.update({
  id: "/intake",
  path: "/intake",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsFirmRoute = AuthSettingsFirmImport.update({
  id: "/firm",
  path: "/firm",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsFilesRoute = AuthSettingsFilesImport.update({
  id: "/files",
  path: "/files",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsContactRoute = AuthSettingsContactImport.update({
  id: "/contact",
  path: "/contact",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthSettingsCommunicationRoute = AuthSettingsCommunicationImport.update({
  id: "/communication",
  path: "/communication",
  getParentRoute: () => AuthSettingsRoute,
} as any);

const AuthReportsUserProductivityRoute =
  AuthReportsUserProductivityImport.update({
    id: "/user-productivity",
    path: "/user-productivity",
    getParentRoute: () => AuthReportsRoute,
  } as any);

const AuthReportsSettlementsRoute = AuthReportsSettlementsImport.update({
  id: "/settlements",
  path: "/settlements",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsSettlementSummaryRoute =
  AuthReportsSettlementSummaryImport.update({
    id: "/settlement-summary",
    path: "/settlement-summary",
    getParentRoute: () => AuthReportsRoute,
  } as any);

const AuthReportsRoleAssignmentsRoute = AuthReportsRoleAssignmentsImport.update(
  {
    id: "/role-assignments",
    path: "/role-assignments",
    getParentRoute: () => AuthReportsRoute,
  } as any,
);

const AuthReportsRecordRequestsRoute = AuthReportsRecordRequestsImport.update({
  id: "/record-requests",
  path: "/record-requests",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsOpenMattersRoute = AuthReportsOpenMattersImport.update({
  id: "/open-matters",
  path: "/open-matters",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsMyApproachingStatutesRoute =
  AuthReportsMyApproachingStatutesImport.update({
    id: "/my-approaching-statutes",
    path: "/my-approaching-statutes",
    getParentRoute: () => AuthReportsRoute,
  } as any);

const AuthReportsMatterStatusCountRoute =
  AuthReportsMatterStatusCountImport.update({
    id: "/matter-status-count",
    path: "/matter-status-count",
    getParentRoute: () => AuthReportsRoute,
  } as any);

const AuthReportsMatterActivityRoute = AuthReportsMatterActivityImport.update({
  id: "/matter-activity",
  path: "/matter-activity",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsDemandsRoute = AuthReportsDemandsImport.update({
  id: "/demands",
  path: "/demands",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsDemandSummaryRoute = AuthReportsDemandSummaryImport.update({
  id: "/demand-summary",
  path: "/demand-summary",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsClosedMattersRoute = AuthReportsClosedMattersImport.update({
  id: "/closed-matters",
  path: "/closed-matters",
  getParentRoute: () => AuthReportsRoute,
} as any);

const AuthReportsCaseAssignmentsRoute = AuthReportsCaseAssignmentsImport.update(
  {
    id: "/case-assignments",
    path: "/case-assignments",
    getParentRoute: () => AuthReportsRoute,
  } as any,
);

const AuthReportsAttorneySummaryRoute = AuthReportsAttorneySummaryImport.update(
  {
    id: "/attorney-summary",
    path: "/attorney-summary",
    getParentRoute: () => AuthReportsRoute,
  } as any,
);

const AuthReportsApproachingStatutesRoute =
  AuthReportsApproachingStatutesImport.update({
    id: "/approaching-statutes",
    path: "/approaching-statutes",
    getParentRoute: () => AuthReportsRoute,
  } as any);

const AuthReferralsSettingsRoute = AuthReferralsSettingsImport.update({
  id: "/referrals/settings",
  path: "/referrals/settings",
  getParentRoute: () => AuthRoute,
} as any);

const AuthReferralsPartnerFirmsRoute = AuthReferralsPartnerFirmsImport.update({
  id: "/referrals/partner-firms",
  path: "/referrals/partner-firms",
  getParentRoute: () => AuthRoute,
} as any);

const AuthReferralsDirectoryProfileRoute =
  AuthReferralsDirectoryProfileImport.update({
    id: "/referrals/directory-profile",
    path: "/referrals/directory-profile",
    getParentRoute: () => AuthRoute,
  } as any);

const AuthReferralsDirectoryRoute = AuthReferralsDirectoryImport.update({
  id: "/referrals/directory",
  path: "/referrals/directory",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMattersSettingsRoute = AuthMattersSettingsImport.update({
  id: "/matters/settings",
  path: "/matters/settings",
  getParentRoute: () => AuthRoute,
} as any);

const AuthMattersMyMattersRoute = AuthMattersMyMattersImport.update({
  id: "/matters/my-matters",
  path: "/matters/my-matters",
  getParentRoute: () => AuthRoute,
} as any);

const AuthFirmReferralProfileRoute = AuthFirmReferralProfileImport.update({
  id: "/firm/referral-profile",
  path: "/firm/referral-profile",
  getParentRoute: () => AuthRoute,
} as any);

const AuthFirmPartnerFirmsRoute = AuthFirmPartnerFirmsImport.update({
  id: "/firm/partner-firms",
  path: "/firm/partner-firms",
  getParentRoute: () => AuthRoute,
} as any);

const AuthFileContentFileContentIdRoute =
  AuthFileContentFileContentIdImport.update({
    id: "/file-content/$fileContentId",
    path: "/file-content/$fileContentId",
    getParentRoute: () => AuthRoute,
  } as any);

const AuthAppsMyAppsRoute = AuthAppsMyAppsImport.update({
  id: "/apps/my-apps",
  path: "/apps/my-apps",
  getParentRoute: () => AuthRoute,
} as any);

const AuthAppsAppLibraryRoute = AuthAppsAppLibraryImport.update({
  id: "/apps/app-library",
  path: "/apps/app-library",
  getParentRoute: () => AuthRoute,
} as any);

const AuthSettingsIntakeIndexRoute = AuthSettingsIntakeIndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthSettingsIntakeRoute,
} as any);

const AuthContactsContactIdIndexRoute = AuthContactsContactIdIndexImport.update(
  {
    id: "/contacts/$contactId/",
    path: "/contacts/$contactId/",
    getParentRoute: () => AuthRoute,
  } as any,
);

const AuthSettingsIntakeTeamsRoute = AuthSettingsIntakeTeamsImport.update({
  id: "/teams",
  path: "/teams",
  getParentRoute: () => AuthSettingsIntakeRoute,
} as any);

const AuthSettingsIntakeTaskPlansRoute =
  AuthSettingsIntakeTaskPlansImport.update({
    id: "/task-plans",
    path: "/task-plans",
    getParentRoute: () => AuthSettingsIntakeRoute,
  } as any);

const AuthSettingsIntakeTagsRoute = AuthSettingsIntakeTagsImport.update({
  id: "/tags",
  path: "/tags",
  getParentRoute: () => AuthSettingsIntakeRoute,
} as any);

const AuthSettingsIntakeStatusesRoute = AuthSettingsIntakeStatusesImport.update(
  {
    id: "/statuses",
    path: "/statuses",
    getParentRoute: () => AuthSettingsIntakeRoute,
  } as any,
);

const AuthSettingsIntakeRolesRoute = AuthSettingsIntakeRolesImport.update({
  id: "/roles",
  path: "/roles",
  getParentRoute: () => AuthSettingsIntakeRoute,
} as any);

const AuthSettingsIntakeMatterTypesRoute =
  AuthSettingsIntakeMatterTypesImport.update({
    id: "/matter-types",
    path: "/matter-types",
    getParentRoute: () => AuthSettingsIntakeRoute,
  } as any);

const AuthSettingsIntakeLeadSourcesRoute =
  AuthSettingsIntakeLeadSourcesImport.update({
    id: "/lead-sources",
    path: "/lead-sources",
    getParentRoute: () => AuthSettingsIntakeRoute,
  } as any);

const AuthReferralsSettingsTeamsRoute = AuthReferralsSettingsTeamsImport.update(
  {
    id: "/teams",
    path: "/teams",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any,
);

const AuthReferralsSettingsTaskPlansRoute =
  AuthReferralsSettingsTaskPlansImport.update({
    id: "/task-plans",
    path: "/task-plans",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any);

const AuthReferralsSettingsTagsRoute = AuthReferralsSettingsTagsImport.update({
  id: "/tags",
  path: "/tags",
  getParentRoute: () => AuthReferralsSettingsRoute,
} as any);

const AuthReferralsSettingsStatusesRoute =
  AuthReferralsSettingsStatusesImport.update({
    id: "/statuses",
    path: "/statuses",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any);

const AuthReferralsSettingsRolesRoute = AuthReferralsSettingsRolesImport.update(
  {
    id: "/roles",
    path: "/roles",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any,
);

const AuthReferralsSettingsProfileRoute =
  AuthReferralsSettingsProfileImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any);

const AuthReferralsSettingsMatterTypesRoute =
  AuthReferralsSettingsMatterTypesImport.update({
    id: "/matter-types",
    path: "/matter-types",
    getParentRoute: () => AuthReferralsSettingsRoute,
  } as any);

const AuthMattersSettingsTeamsRoute = AuthMattersSettingsTeamsImport.update({
  id: "/teams",
  path: "/teams",
  getParentRoute: () => AuthMattersSettingsRoute,
} as any);

const AuthMattersSettingsTaskPlansRoute =
  AuthMattersSettingsTaskPlansImport.update({
    id: "/task-plans",
    path: "/task-plans",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsTagsRoute = AuthMattersSettingsTagsImport.update({
  id: "/tags",
  path: "/tags",
  getParentRoute: () => AuthMattersSettingsRoute,
} as any);

const AuthMattersSettingsStatusesRoute =
  AuthMattersSettingsStatusesImport.update({
    id: "/statuses",
    path: "/statuses",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsScheduledMessagesRoute =
  AuthMattersSettingsScheduledMessagesImport.update({
    id: "/scheduled-messages",
    path: "/scheduled-messages",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsRolesRoute = AuthMattersSettingsRolesImport.update({
  id: "/roles",
  path: "/roles",
  getParentRoute: () => AuthMattersSettingsRoute,
} as any);

const AuthMattersSettingsPhaseProjectsRoute =
  AuthMattersSettingsPhaseProjectsImport.update({
    id: "/phase-projects",
    path: "/phase-projects",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsMatterTypesRoute =
  AuthMattersSettingsMatterTypesImport.update({
    id: "/matter-types",
    path: "/matter-types",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsLitigationPlansRoute =
  AuthMattersSettingsLitigationPlansImport.update({
    id: "/litigation-plans",
    path: "/litigation-plans",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsIntakeTemplatesRoute =
  AuthMattersSettingsIntakeTemplatesImport.update({
    id: "/intake-templates",
    path: "/intake-templates",
    getParentRoute: () => AuthMattersSettingsRoute,
  } as any);

const AuthMattersSettingsFilesRoute = AuthMattersSettingsFilesImport.update({
  id: "/files",
  path: "/files",
  getParentRoute: () => AuthMattersSettingsRoute,
} as any);

const AuthMattersSettingsCostsRoute = AuthMattersSettingsCostsImport.update({
  id: "/costs",
  path: "/costs",
  getParentRoute: () => AuthMattersSettingsRoute,
} as any);

const AuthMattersMatterIdLayoutRoute = AuthMattersMatterIdLayoutImport.update({
  id: "/_layout",
  getParentRoute: () => AuthMattersMatterIdRoute,
} as any);

const AuthMassTortsMassTortSearchIdLayoutRoute =
  AuthMassTortsMassTortSearchIdLayoutImport.update({
    id: "/_layout",
    getParentRoute: () => AuthMassTortsMassTortSearchIdRoute,
  } as any);

const AuthMattersMatterIdLayoutIndexRoute =
  AuthMattersMatterIdLayoutIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutIndexRoute =
  AuthMassTortsMassTortSearchIdLayoutIndexImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutUpdatesRoute =
  AuthMattersMatterIdLayoutUpdatesImport.update({
    id: "/updates",
    path: "/updates",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutTasksRoute =
  AuthMattersMatterIdLayoutTasksImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutSignatureRequestsRoute =
  AuthMattersMatterIdLayoutSignatureRequestsImport.update({
    id: "/signature-requests",
    path: "/signature-requests",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutSettlementsRoute =
  AuthMattersMatterIdLayoutSettlementsImport.update({
    id: "/settlements",
    path: "/settlements",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutPropertyDamageRoute =
  AuthMattersMatterIdLayoutPropertyDamageImport.update({
    id: "/property-damage",
    path: "/property-damage",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutNotesRoute =
  AuthMattersMatterIdLayoutNotesImport.update({
    id: "/notes",
    path: "/notes",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutMedicalTreatmentsRoute =
  AuthMattersMatterIdLayoutMedicalTreatmentsImport.update({
    id: "/medical-treatments",
    path: "/medical-treatments",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutLitigationRoute =
  AuthMattersMatterIdLayoutLitigationImport.update({
    id: "/litigation",
    path: "/litigation",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutLiensRoute =
  AuthMattersMatterIdLayoutLiensImport.update({
    id: "/liens",
    path: "/liens",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutIncidentDetailsRoute =
  AuthMattersMatterIdLayoutIncidentDetailsImport.update({
    id: "/incident-details",
    path: "/incident-details",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutFilesRoute =
  AuthMattersMatterIdLayoutFilesImport.update({
    id: "/files",
    path: "/files",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutEmailsRoute =
  AuthMattersMatterIdLayoutEmailsImport.update({
    id: "/emails",
    path: "/emails",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutCustomFieldsRoute =
  AuthMattersMatterIdLayoutCustomFieldsImport.update({
    id: "/custom-fields",
    path: "/custom-fields",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutCostsRoute =
  AuthMattersMatterIdLayoutCostsImport.update({
    id: "/costs",
    path: "/costs",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutChargesRoute =
  AuthMattersMatterIdLayoutChargesImport.update({
    id: "/charges",
    path: "/charges",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutTasksRoute =
  AuthMassTortsMassTortSearchIdLayoutTasksImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutSurveysRoute =
  AuthMassTortsMassTortSearchIdLayoutSurveysImport.update({
    id: "/surveys",
    path: "/surveys",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutNotesRoute =
  AuthMassTortsMassTortSearchIdLayoutNotesImport.update({
    id: "/notes",
    path: "/notes",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutFilesRoute =
  AuthMassTortsMassTortSearchIdLayoutFilesImport.update({
    id: "/files",
    path: "/files",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute =
  AuthMassTortsMassTortSearchIdLayoutFileGenerationImport.update({
    id: "/file-generation",
    path: "/file-generation",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute =
  AuthMassTortsMassTortSearchIdLayoutCustomFieldsImport.update({
    id: "/custom-fields",
    path: "/custom-fields",
    getParentRoute: () => AuthMassTortsMassTortSearchIdLayoutRoute,
  } as any);

const AuthMattersMatterIdLayoutMatterDetailsTabRoute =
  AuthMattersMatterIdLayoutMatterDetailsTabImport.update({
    id: "/matter-details/$tab",
    path: "/matter-details/$tab",
    getParentRoute: () => AuthMattersMatterIdLayoutRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_auth": {
      id: "/_auth";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthImport;
      parentRoute: typeof rootRoute;
    };
    "/change-password": {
      id: "/change-password";
      path: "/change-password";
      fullPath: "/change-password";
      preLoaderRoute: typeof ChangePasswordImport;
      parentRoute: typeof rootRoute;
    };
    "/file-share": {
      id: "/file-share";
      path: "/file-share";
      fullPath: "/file-share";
      preLoaderRoute: typeof FileShareImport;
      parentRoute: typeof rootRoute;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordImport;
      parentRoute: typeof rootRoute;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    "/register": {
      id: "/register";
      path: "/register";
      fullPath: "/register";
      preLoaderRoute: typeof RegisterImport;
      parentRoute: typeof rootRoute;
    };
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordImport;
      parentRoute: typeof rootRoute;
    };
    "/sign": {
      id: "/sign";
      path: "/sign";
      fullPath: "/sign";
      preLoaderRoute: typeof SignImport;
      parentRoute: typeof rootRoute;
    };
    "/_auth/ai": {
      id: "/_auth/ai";
      path: "/ai";
      fullPath: "/ai";
      preLoaderRoute: typeof AuthAiImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/automations": {
      id: "/_auth/automations";
      path: "/automations";
      fullPath: "/automations";
      preLoaderRoute: typeof AuthAutomationsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/charges": {
      id: "/_auth/charges";
      path: "/charges";
      fullPath: "/charges";
      preLoaderRoute: typeof AuthChargesImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/files": {
      id: "/_auth/files";
      path: "/files";
      fullPath: "/files";
      preLoaderRoute: typeof AuthFilesImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/mail-sorting": {
      id: "/_auth/mail-sorting";
      path: "/mail-sorting";
      fullPath: "/mail-sorting";
      preLoaderRoute: typeof AuthMailSortingImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/reports": {
      id: "/_auth/reports";
      path: "/reports";
      fullPath: "/reports";
      preLoaderRoute: typeof AuthReportsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/settings": {
      id: "/_auth/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AuthSettingsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/signature-requests": {
      id: "/_auth/signature-requests";
      path: "/signature-requests";
      fullPath: "/signature-requests";
      preLoaderRoute: typeof AuthSignatureRequestsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/skills": {
      id: "/_auth/skills";
      path: "/skills";
      fullPath: "/skills";
      preLoaderRoute: typeof AuthSkillsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/": {
      id: "/_auth/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/onboarding/": {
      id: "/onboarding/";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof OnboardingIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/_auth/apps/app-library": {
      id: "/_auth/apps/app-library";
      path: "/apps/app-library";
      fullPath: "/apps/app-library";
      preLoaderRoute: typeof AuthAppsAppLibraryImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/apps/my-apps": {
      id: "/_auth/apps/my-apps";
      path: "/apps/my-apps";
      fullPath: "/apps/my-apps";
      preLoaderRoute: typeof AuthAppsMyAppsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/file-content/$fileContentId": {
      id: "/_auth/file-content/$fileContentId";
      path: "/file-content/$fileContentId";
      fullPath: "/file-content/$fileContentId";
      preLoaderRoute: typeof AuthFileContentFileContentIdImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/firm/partner-firms": {
      id: "/_auth/firm/partner-firms";
      path: "/firm/partner-firms";
      fullPath: "/firm/partner-firms";
      preLoaderRoute: typeof AuthFirmPartnerFirmsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/firm/referral-profile": {
      id: "/_auth/firm/referral-profile";
      path: "/firm/referral-profile";
      fullPath: "/firm/referral-profile";
      preLoaderRoute: typeof AuthFirmReferralProfileImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/matters/my-matters": {
      id: "/_auth/matters/my-matters";
      path: "/matters/my-matters";
      fullPath: "/matters/my-matters";
      preLoaderRoute: typeof AuthMattersMyMattersImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/matters/settings": {
      id: "/_auth/matters/settings";
      path: "/matters/settings";
      fullPath: "/matters/settings";
      preLoaderRoute: typeof AuthMattersSettingsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/referrals/directory": {
      id: "/_auth/referrals/directory";
      path: "/referrals/directory";
      fullPath: "/referrals/directory";
      preLoaderRoute: typeof AuthReferralsDirectoryImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/referrals/directory-profile": {
      id: "/_auth/referrals/directory-profile";
      path: "/referrals/directory-profile";
      fullPath: "/referrals/directory-profile";
      preLoaderRoute: typeof AuthReferralsDirectoryProfileImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/referrals/partner-firms": {
      id: "/_auth/referrals/partner-firms";
      path: "/referrals/partner-firms";
      fullPath: "/referrals/partner-firms";
      preLoaderRoute: typeof AuthReferralsPartnerFirmsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/referrals/settings": {
      id: "/_auth/referrals/settings";
      path: "/referrals/settings";
      fullPath: "/referrals/settings";
      preLoaderRoute: typeof AuthReferralsSettingsImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/reports/approaching-statutes": {
      id: "/_auth/reports/approaching-statutes";
      path: "/approaching-statutes";
      fullPath: "/reports/approaching-statutes";
      preLoaderRoute: typeof AuthReportsApproachingStatutesImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/attorney-summary": {
      id: "/_auth/reports/attorney-summary";
      path: "/attorney-summary";
      fullPath: "/reports/attorney-summary";
      preLoaderRoute: typeof AuthReportsAttorneySummaryImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/case-assignments": {
      id: "/_auth/reports/case-assignments";
      path: "/case-assignments";
      fullPath: "/reports/case-assignments";
      preLoaderRoute: typeof AuthReportsCaseAssignmentsImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/closed-matters": {
      id: "/_auth/reports/closed-matters";
      path: "/closed-matters";
      fullPath: "/reports/closed-matters";
      preLoaderRoute: typeof AuthReportsClosedMattersImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/demand-summary": {
      id: "/_auth/reports/demand-summary";
      path: "/demand-summary";
      fullPath: "/reports/demand-summary";
      preLoaderRoute: typeof AuthReportsDemandSummaryImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/demands": {
      id: "/_auth/reports/demands";
      path: "/demands";
      fullPath: "/reports/demands";
      preLoaderRoute: typeof AuthReportsDemandsImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/matter-activity": {
      id: "/_auth/reports/matter-activity";
      path: "/matter-activity";
      fullPath: "/reports/matter-activity";
      preLoaderRoute: typeof AuthReportsMatterActivityImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/matter-status-count": {
      id: "/_auth/reports/matter-status-count";
      path: "/matter-status-count";
      fullPath: "/reports/matter-status-count";
      preLoaderRoute: typeof AuthReportsMatterStatusCountImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/my-approaching-statutes": {
      id: "/_auth/reports/my-approaching-statutes";
      path: "/my-approaching-statutes";
      fullPath: "/reports/my-approaching-statutes";
      preLoaderRoute: typeof AuthReportsMyApproachingStatutesImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/open-matters": {
      id: "/_auth/reports/open-matters";
      path: "/open-matters";
      fullPath: "/reports/open-matters";
      preLoaderRoute: typeof AuthReportsOpenMattersImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/record-requests": {
      id: "/_auth/reports/record-requests";
      path: "/record-requests";
      fullPath: "/reports/record-requests";
      preLoaderRoute: typeof AuthReportsRecordRequestsImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/role-assignments": {
      id: "/_auth/reports/role-assignments";
      path: "/role-assignments";
      fullPath: "/reports/role-assignments";
      preLoaderRoute: typeof AuthReportsRoleAssignmentsImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/settlement-summary": {
      id: "/_auth/reports/settlement-summary";
      path: "/settlement-summary";
      fullPath: "/reports/settlement-summary";
      preLoaderRoute: typeof AuthReportsSettlementSummaryImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/settlements": {
      id: "/_auth/reports/settlements";
      path: "/settlements";
      fullPath: "/reports/settlements";
      preLoaderRoute: typeof AuthReportsSettlementsImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/reports/user-productivity": {
      id: "/_auth/reports/user-productivity";
      path: "/user-productivity";
      fullPath: "/reports/user-productivity";
      preLoaderRoute: typeof AuthReportsUserProductivityImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/settings/communication": {
      id: "/_auth/settings/communication";
      path: "/communication";
      fullPath: "/settings/communication";
      preLoaderRoute: typeof AuthSettingsCommunicationImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/contact": {
      id: "/_auth/settings/contact";
      path: "/contact";
      fullPath: "/settings/contact";
      preLoaderRoute: typeof AuthSettingsContactImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/files": {
      id: "/_auth/settings/files";
      path: "/files";
      fullPath: "/settings/files";
      preLoaderRoute: typeof AuthSettingsFilesImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/firm": {
      id: "/_auth/settings/firm";
      path: "/firm";
      fullPath: "/settings/firm";
      preLoaderRoute: typeof AuthSettingsFirmImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/intake": {
      id: "/_auth/settings/intake";
      path: "/intake";
      fullPath: "/settings/intake";
      preLoaderRoute: typeof AuthSettingsIntakeImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/matter-defaults": {
      id: "/_auth/settings/matter-defaults";
      path: "/matter-defaults";
      fullPath: "/settings/matter-defaults";
      preLoaderRoute: typeof AuthSettingsMatterDefaultsImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/matter-types": {
      id: "/_auth/settings/matter-types";
      path: "/matter-types";
      fullPath: "/settings/matter-types";
      preLoaderRoute: typeof AuthSettingsMatterTypesImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/templates": {
      id: "/_auth/settings/templates";
      path: "/templates";
      fullPath: "/settings/templates";
      preLoaderRoute: typeof AuthSettingsTemplatesImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/settings/users": {
      id: "/_auth/settings/users";
      path: "/users";
      fullPath: "/settings/users";
      preLoaderRoute: typeof AuthSettingsUsersImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/apps/": {
      id: "/_auth/apps/";
      path: "/apps";
      fullPath: "/apps";
      preLoaderRoute: typeof AuthAppsIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/contacts/": {
      id: "/_auth/contacts/";
      path: "/contacts";
      fullPath: "/contacts";
      preLoaderRoute: typeof AuthContactsIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/leads/": {
      id: "/_auth/leads/";
      path: "/leads";
      fullPath: "/leads";
      preLoaderRoute: typeof AuthLeadsIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/mass-torts/": {
      id: "/_auth/mass-torts/";
      path: "/mass-torts";
      fullPath: "/mass-torts";
      preLoaderRoute: typeof AuthMassTortsIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/matters/": {
      id: "/_auth/matters/";
      path: "/matters";
      fullPath: "/matters";
      preLoaderRoute: typeof AuthMattersIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/opportunities/": {
      id: "/_auth/opportunities/";
      path: "/opportunities";
      fullPath: "/opportunities";
      preLoaderRoute: typeof AuthOpportunitiesIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/profile/": {
      id: "/_auth/profile/";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof AuthProfileIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/referrals/": {
      id: "/_auth/referrals/";
      path: "/referrals";
      fullPath: "/referrals";
      preLoaderRoute: typeof AuthReferralsIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/reports/": {
      id: "/_auth/reports/";
      path: "/";
      fullPath: "/reports/";
      preLoaderRoute: typeof AuthReportsIndexImport;
      parentRoute: typeof AuthReportsImport;
    };
    "/_auth/settings/": {
      id: "/_auth/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof AuthSettingsIndexImport;
      parentRoute: typeof AuthSettingsImport;
    };
    "/_auth/mass-torts/$massTortSearchId": {
      id: "/_auth/mass-torts/$massTortSearchId";
      path: "/mass-torts/$massTortSearchId";
      fullPath: "/mass-torts/$massTortSearchId";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout";
      path: "/mass-torts/$massTortSearchId";
      fullPath: "/mass-torts/$massTortSearchId";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdRoute;
    };
    "/_auth/matters/$matterId": {
      id: "/_auth/matters/$matterId";
      path: "/matters/$matterId";
      fullPath: "/matters/$matterId";
      preLoaderRoute: typeof AuthMattersMatterIdImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/matters/$matterId/_layout": {
      id: "/_auth/matters/$matterId/_layout";
      path: "/matters/$matterId";
      fullPath: "/matters/$matterId";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutImport;
      parentRoute: typeof AuthMattersMatterIdRoute;
    };
    "/_auth/matters/settings/costs": {
      id: "/_auth/matters/settings/costs";
      path: "/costs";
      fullPath: "/matters/settings/costs";
      preLoaderRoute: typeof AuthMattersSettingsCostsImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/files": {
      id: "/_auth/matters/settings/files";
      path: "/files";
      fullPath: "/matters/settings/files";
      preLoaderRoute: typeof AuthMattersSettingsFilesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/intake-templates": {
      id: "/_auth/matters/settings/intake-templates";
      path: "/intake-templates";
      fullPath: "/matters/settings/intake-templates";
      preLoaderRoute: typeof AuthMattersSettingsIntakeTemplatesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/litigation-plans": {
      id: "/_auth/matters/settings/litigation-plans";
      path: "/litigation-plans";
      fullPath: "/matters/settings/litigation-plans";
      preLoaderRoute: typeof AuthMattersSettingsLitigationPlansImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/matter-types": {
      id: "/_auth/matters/settings/matter-types";
      path: "/matter-types";
      fullPath: "/matters/settings/matter-types";
      preLoaderRoute: typeof AuthMattersSettingsMatterTypesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/phase-projects": {
      id: "/_auth/matters/settings/phase-projects";
      path: "/phase-projects";
      fullPath: "/matters/settings/phase-projects";
      preLoaderRoute: typeof AuthMattersSettingsPhaseProjectsImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/roles": {
      id: "/_auth/matters/settings/roles";
      path: "/roles";
      fullPath: "/matters/settings/roles";
      preLoaderRoute: typeof AuthMattersSettingsRolesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/scheduled-messages": {
      id: "/_auth/matters/settings/scheduled-messages";
      path: "/scheduled-messages";
      fullPath: "/matters/settings/scheduled-messages";
      preLoaderRoute: typeof AuthMattersSettingsScheduledMessagesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/statuses": {
      id: "/_auth/matters/settings/statuses";
      path: "/statuses";
      fullPath: "/matters/settings/statuses";
      preLoaderRoute: typeof AuthMattersSettingsStatusesImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/tags": {
      id: "/_auth/matters/settings/tags";
      path: "/tags";
      fullPath: "/matters/settings/tags";
      preLoaderRoute: typeof AuthMattersSettingsTagsImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/task-plans": {
      id: "/_auth/matters/settings/task-plans";
      path: "/task-plans";
      fullPath: "/matters/settings/task-plans";
      preLoaderRoute: typeof AuthMattersSettingsTaskPlansImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/matters/settings/teams": {
      id: "/_auth/matters/settings/teams";
      path: "/teams";
      fullPath: "/matters/settings/teams";
      preLoaderRoute: typeof AuthMattersSettingsTeamsImport;
      parentRoute: typeof AuthMattersSettingsImport;
    };
    "/_auth/referrals/settings/matter-types": {
      id: "/_auth/referrals/settings/matter-types";
      path: "/matter-types";
      fullPath: "/referrals/settings/matter-types";
      preLoaderRoute: typeof AuthReferralsSettingsMatterTypesImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/profile": {
      id: "/_auth/referrals/settings/profile";
      path: "/profile";
      fullPath: "/referrals/settings/profile";
      preLoaderRoute: typeof AuthReferralsSettingsProfileImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/roles": {
      id: "/_auth/referrals/settings/roles";
      path: "/roles";
      fullPath: "/referrals/settings/roles";
      preLoaderRoute: typeof AuthReferralsSettingsRolesImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/statuses": {
      id: "/_auth/referrals/settings/statuses";
      path: "/statuses";
      fullPath: "/referrals/settings/statuses";
      preLoaderRoute: typeof AuthReferralsSettingsStatusesImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/tags": {
      id: "/_auth/referrals/settings/tags";
      path: "/tags";
      fullPath: "/referrals/settings/tags";
      preLoaderRoute: typeof AuthReferralsSettingsTagsImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/task-plans": {
      id: "/_auth/referrals/settings/task-plans";
      path: "/task-plans";
      fullPath: "/referrals/settings/task-plans";
      preLoaderRoute: typeof AuthReferralsSettingsTaskPlansImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/referrals/settings/teams": {
      id: "/_auth/referrals/settings/teams";
      path: "/teams";
      fullPath: "/referrals/settings/teams";
      preLoaderRoute: typeof AuthReferralsSettingsTeamsImport;
      parentRoute: typeof AuthReferralsSettingsImport;
    };
    "/_auth/settings/intake/lead-sources": {
      id: "/_auth/settings/intake/lead-sources";
      path: "/lead-sources";
      fullPath: "/settings/intake/lead-sources";
      preLoaderRoute: typeof AuthSettingsIntakeLeadSourcesImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/matter-types": {
      id: "/_auth/settings/intake/matter-types";
      path: "/matter-types";
      fullPath: "/settings/intake/matter-types";
      preLoaderRoute: typeof AuthSettingsIntakeMatterTypesImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/roles": {
      id: "/_auth/settings/intake/roles";
      path: "/roles";
      fullPath: "/settings/intake/roles";
      preLoaderRoute: typeof AuthSettingsIntakeRolesImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/statuses": {
      id: "/_auth/settings/intake/statuses";
      path: "/statuses";
      fullPath: "/settings/intake/statuses";
      preLoaderRoute: typeof AuthSettingsIntakeStatusesImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/tags": {
      id: "/_auth/settings/intake/tags";
      path: "/tags";
      fullPath: "/settings/intake/tags";
      preLoaderRoute: typeof AuthSettingsIntakeTagsImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/task-plans": {
      id: "/_auth/settings/intake/task-plans";
      path: "/task-plans";
      fullPath: "/settings/intake/task-plans";
      preLoaderRoute: typeof AuthSettingsIntakeTaskPlansImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/settings/intake/teams": {
      id: "/_auth/settings/intake/teams";
      path: "/teams";
      fullPath: "/settings/intake/teams";
      preLoaderRoute: typeof AuthSettingsIntakeTeamsImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/contacts/$contactId/": {
      id: "/_auth/contacts/$contactId/";
      path: "/contacts/$contactId";
      fullPath: "/contacts/$contactId";
      preLoaderRoute: typeof AuthContactsContactIdIndexImport;
      parentRoute: typeof AuthImport;
    };
    "/_auth/settings/intake/": {
      id: "/_auth/settings/intake/";
      path: "/";
      fullPath: "/settings/intake/";
      preLoaderRoute: typeof AuthSettingsIntakeIndexImport;
      parentRoute: typeof AuthSettingsIntakeImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields";
      path: "/custom-fields";
      fullPath: "/mass-torts/$massTortSearchId/custom-fields";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutCustomFieldsImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/file-generation": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/file-generation";
      path: "/file-generation";
      fullPath: "/mass-torts/$massTortSearchId/file-generation";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutFileGenerationImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/files": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/files";
      path: "/files";
      fullPath: "/mass-torts/$massTortSearchId/files";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutFilesImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/notes": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/notes";
      path: "/notes";
      fullPath: "/mass-torts/$massTortSearchId/notes";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutNotesImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/surveys": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/surveys";
      path: "/surveys";
      fullPath: "/mass-torts/$massTortSearchId/surveys";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutSurveysImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/tasks": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/tasks";
      path: "/tasks";
      fullPath: "/mass-torts/$massTortSearchId/tasks";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutTasksImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/charges": {
      id: "/_auth/matters/$matterId/_layout/charges";
      path: "/charges";
      fullPath: "/matters/$matterId/charges";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutChargesImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/costs": {
      id: "/_auth/matters/$matterId/_layout/costs";
      path: "/costs";
      fullPath: "/matters/$matterId/costs";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutCostsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/custom-fields": {
      id: "/_auth/matters/$matterId/_layout/custom-fields";
      path: "/custom-fields";
      fullPath: "/matters/$matterId/custom-fields";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutCustomFieldsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/emails": {
      id: "/_auth/matters/$matterId/_layout/emails";
      path: "/emails";
      fullPath: "/matters/$matterId/emails";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutEmailsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/files": {
      id: "/_auth/matters/$matterId/_layout/files";
      path: "/files";
      fullPath: "/matters/$matterId/files";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutFilesImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/incident-details": {
      id: "/_auth/matters/$matterId/_layout/incident-details";
      path: "/incident-details";
      fullPath: "/matters/$matterId/incident-details";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutIncidentDetailsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/liens": {
      id: "/_auth/matters/$matterId/_layout/liens";
      path: "/liens";
      fullPath: "/matters/$matterId/liens";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutLiensImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/litigation": {
      id: "/_auth/matters/$matterId/_layout/litigation";
      path: "/litigation";
      fullPath: "/matters/$matterId/litigation";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutLitigationImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/medical-treatments": {
      id: "/_auth/matters/$matterId/_layout/medical-treatments";
      path: "/medical-treatments";
      fullPath: "/matters/$matterId/medical-treatments";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutMedicalTreatmentsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/notes": {
      id: "/_auth/matters/$matterId/_layout/notes";
      path: "/notes";
      fullPath: "/matters/$matterId/notes";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutNotesImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/property-damage": {
      id: "/_auth/matters/$matterId/_layout/property-damage";
      path: "/property-damage";
      fullPath: "/matters/$matterId/property-damage";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutPropertyDamageImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/settlements": {
      id: "/_auth/matters/$matterId/_layout/settlements";
      path: "/settlements";
      fullPath: "/matters/$matterId/settlements";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutSettlementsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/signature-requests": {
      id: "/_auth/matters/$matterId/_layout/signature-requests";
      path: "/signature-requests";
      fullPath: "/matters/$matterId/signature-requests";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutSignatureRequestsImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/tasks": {
      id: "/_auth/matters/$matterId/_layout/tasks";
      path: "/tasks";
      fullPath: "/matters/$matterId/tasks";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutTasksImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/updates": {
      id: "/_auth/matters/$matterId/_layout/updates";
      path: "/updates";
      fullPath: "/matters/$matterId/updates";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutUpdatesImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/mass-torts/$massTortSearchId/_layout/": {
      id: "/_auth/mass-torts/$massTortSearchId/_layout/";
      path: "/";
      fullPath: "/mass-torts/$massTortSearchId/";
      preLoaderRoute: typeof AuthMassTortsMassTortSearchIdLayoutIndexImport;
      parentRoute: typeof AuthMassTortsMassTortSearchIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/": {
      id: "/_auth/matters/$matterId/_layout/";
      path: "/";
      fullPath: "/matters/$matterId/";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutIndexImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
    "/_auth/matters/$matterId/_layout/matter-details/$tab": {
      id: "/_auth/matters/$matterId/_layout/matter-details/$tab";
      path: "/matter-details/$tab";
      fullPath: "/matters/$matterId/matter-details/$tab";
      preLoaderRoute: typeof AuthMattersMatterIdLayoutMatterDetailsTabImport;
      parentRoute: typeof AuthMattersMatterIdLayoutImport;
    };
  }
}

// Create and export the route tree

interface AuthReportsRouteChildren {
  AuthReportsApproachingStatutesRoute: typeof AuthReportsApproachingStatutesRoute;
  AuthReportsAttorneySummaryRoute: typeof AuthReportsAttorneySummaryRoute;
  AuthReportsCaseAssignmentsRoute: typeof AuthReportsCaseAssignmentsRoute;
  AuthReportsClosedMattersRoute: typeof AuthReportsClosedMattersRoute;
  AuthReportsDemandSummaryRoute: typeof AuthReportsDemandSummaryRoute;
  AuthReportsDemandsRoute: typeof AuthReportsDemandsRoute;
  AuthReportsMatterActivityRoute: typeof AuthReportsMatterActivityRoute;
  AuthReportsMatterStatusCountRoute: typeof AuthReportsMatterStatusCountRoute;
  AuthReportsMyApproachingStatutesRoute: typeof AuthReportsMyApproachingStatutesRoute;
  AuthReportsOpenMattersRoute: typeof AuthReportsOpenMattersRoute;
  AuthReportsRecordRequestsRoute: typeof AuthReportsRecordRequestsRoute;
  AuthReportsRoleAssignmentsRoute: typeof AuthReportsRoleAssignmentsRoute;
  AuthReportsSettlementSummaryRoute: typeof AuthReportsSettlementSummaryRoute;
  AuthReportsSettlementsRoute: typeof AuthReportsSettlementsRoute;
  AuthReportsUserProductivityRoute: typeof AuthReportsUserProductivityRoute;
  AuthReportsIndexRoute: typeof AuthReportsIndexRoute;
}

const AuthReportsRouteChildren: AuthReportsRouteChildren = {
  AuthReportsApproachingStatutesRoute: AuthReportsApproachingStatutesRoute,
  AuthReportsAttorneySummaryRoute: AuthReportsAttorneySummaryRoute,
  AuthReportsCaseAssignmentsRoute: AuthReportsCaseAssignmentsRoute,
  AuthReportsClosedMattersRoute: AuthReportsClosedMattersRoute,
  AuthReportsDemandSummaryRoute: AuthReportsDemandSummaryRoute,
  AuthReportsDemandsRoute: AuthReportsDemandsRoute,
  AuthReportsMatterActivityRoute: AuthReportsMatterActivityRoute,
  AuthReportsMatterStatusCountRoute: AuthReportsMatterStatusCountRoute,
  AuthReportsMyApproachingStatutesRoute: AuthReportsMyApproachingStatutesRoute,
  AuthReportsOpenMattersRoute: AuthReportsOpenMattersRoute,
  AuthReportsRecordRequestsRoute: AuthReportsRecordRequestsRoute,
  AuthReportsRoleAssignmentsRoute: AuthReportsRoleAssignmentsRoute,
  AuthReportsSettlementSummaryRoute: AuthReportsSettlementSummaryRoute,
  AuthReportsSettlementsRoute: AuthReportsSettlementsRoute,
  AuthReportsUserProductivityRoute: AuthReportsUserProductivityRoute,
  AuthReportsIndexRoute: AuthReportsIndexRoute,
};

const AuthReportsRouteWithChildren = AuthReportsRoute._addFileChildren(
  AuthReportsRouteChildren,
);

interface AuthSettingsIntakeRouteChildren {
  AuthSettingsIntakeLeadSourcesRoute: typeof AuthSettingsIntakeLeadSourcesRoute;
  AuthSettingsIntakeMatterTypesRoute: typeof AuthSettingsIntakeMatterTypesRoute;
  AuthSettingsIntakeRolesRoute: typeof AuthSettingsIntakeRolesRoute;
  AuthSettingsIntakeStatusesRoute: typeof AuthSettingsIntakeStatusesRoute;
  AuthSettingsIntakeTagsRoute: typeof AuthSettingsIntakeTagsRoute;
  AuthSettingsIntakeTaskPlansRoute: typeof AuthSettingsIntakeTaskPlansRoute;
  AuthSettingsIntakeTeamsRoute: typeof AuthSettingsIntakeTeamsRoute;
  AuthSettingsIntakeIndexRoute: typeof AuthSettingsIntakeIndexRoute;
}

const AuthSettingsIntakeRouteChildren: AuthSettingsIntakeRouteChildren = {
  AuthSettingsIntakeLeadSourcesRoute: AuthSettingsIntakeLeadSourcesRoute,
  AuthSettingsIntakeMatterTypesRoute: AuthSettingsIntakeMatterTypesRoute,
  AuthSettingsIntakeRolesRoute: AuthSettingsIntakeRolesRoute,
  AuthSettingsIntakeStatusesRoute: AuthSettingsIntakeStatusesRoute,
  AuthSettingsIntakeTagsRoute: AuthSettingsIntakeTagsRoute,
  AuthSettingsIntakeTaskPlansRoute: AuthSettingsIntakeTaskPlansRoute,
  AuthSettingsIntakeTeamsRoute: AuthSettingsIntakeTeamsRoute,
  AuthSettingsIntakeIndexRoute: AuthSettingsIntakeIndexRoute,
};

const AuthSettingsIntakeRouteWithChildren =
  AuthSettingsIntakeRoute._addFileChildren(AuthSettingsIntakeRouteChildren);

interface AuthSettingsRouteChildren {
  AuthSettingsCommunicationRoute: typeof AuthSettingsCommunicationRoute;
  AuthSettingsContactRoute: typeof AuthSettingsContactRoute;
  AuthSettingsFilesRoute: typeof AuthSettingsFilesRoute;
  AuthSettingsFirmRoute: typeof AuthSettingsFirmRoute;
  AuthSettingsIntakeRoute: typeof AuthSettingsIntakeRouteWithChildren;
  AuthSettingsMatterDefaultsRoute: typeof AuthSettingsMatterDefaultsRoute;
  AuthSettingsMatterTypesRoute: typeof AuthSettingsMatterTypesRoute;
  AuthSettingsTemplatesRoute: typeof AuthSettingsTemplatesRoute;
  AuthSettingsUsersRoute: typeof AuthSettingsUsersRoute;
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute;
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsCommunicationRoute: AuthSettingsCommunicationRoute,
  AuthSettingsContactRoute: AuthSettingsContactRoute,
  AuthSettingsFilesRoute: AuthSettingsFilesRoute,
  AuthSettingsFirmRoute: AuthSettingsFirmRoute,
  AuthSettingsIntakeRoute: AuthSettingsIntakeRouteWithChildren,
  AuthSettingsMatterDefaultsRoute: AuthSettingsMatterDefaultsRoute,
  AuthSettingsMatterTypesRoute: AuthSettingsMatterTypesRoute,
  AuthSettingsTemplatesRoute: AuthSettingsTemplatesRoute,
  AuthSettingsUsersRoute: AuthSettingsUsersRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
};

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
);

interface AuthMattersSettingsRouteChildren {
  AuthMattersSettingsCostsRoute: typeof AuthMattersSettingsCostsRoute;
  AuthMattersSettingsFilesRoute: typeof AuthMattersSettingsFilesRoute;
  AuthMattersSettingsIntakeTemplatesRoute: typeof AuthMattersSettingsIntakeTemplatesRoute;
  AuthMattersSettingsLitigationPlansRoute: typeof AuthMattersSettingsLitigationPlansRoute;
  AuthMattersSettingsMatterTypesRoute: typeof AuthMattersSettingsMatterTypesRoute;
  AuthMattersSettingsPhaseProjectsRoute: typeof AuthMattersSettingsPhaseProjectsRoute;
  AuthMattersSettingsRolesRoute: typeof AuthMattersSettingsRolesRoute;
  AuthMattersSettingsScheduledMessagesRoute: typeof AuthMattersSettingsScheduledMessagesRoute;
  AuthMattersSettingsStatusesRoute: typeof AuthMattersSettingsStatusesRoute;
  AuthMattersSettingsTagsRoute: typeof AuthMattersSettingsTagsRoute;
  AuthMattersSettingsTaskPlansRoute: typeof AuthMattersSettingsTaskPlansRoute;
  AuthMattersSettingsTeamsRoute: typeof AuthMattersSettingsTeamsRoute;
}

const AuthMattersSettingsRouteChildren: AuthMattersSettingsRouteChildren = {
  AuthMattersSettingsCostsRoute: AuthMattersSettingsCostsRoute,
  AuthMattersSettingsFilesRoute: AuthMattersSettingsFilesRoute,
  AuthMattersSettingsIntakeTemplatesRoute:
    AuthMattersSettingsIntakeTemplatesRoute,
  AuthMattersSettingsLitigationPlansRoute:
    AuthMattersSettingsLitigationPlansRoute,
  AuthMattersSettingsMatterTypesRoute: AuthMattersSettingsMatterTypesRoute,
  AuthMattersSettingsPhaseProjectsRoute: AuthMattersSettingsPhaseProjectsRoute,
  AuthMattersSettingsRolesRoute: AuthMattersSettingsRolesRoute,
  AuthMattersSettingsScheduledMessagesRoute:
    AuthMattersSettingsScheduledMessagesRoute,
  AuthMattersSettingsStatusesRoute: AuthMattersSettingsStatusesRoute,
  AuthMattersSettingsTagsRoute: AuthMattersSettingsTagsRoute,
  AuthMattersSettingsTaskPlansRoute: AuthMattersSettingsTaskPlansRoute,
  AuthMattersSettingsTeamsRoute: AuthMattersSettingsTeamsRoute,
};

const AuthMattersSettingsRouteWithChildren =
  AuthMattersSettingsRoute._addFileChildren(AuthMattersSettingsRouteChildren);

interface AuthReferralsSettingsRouteChildren {
  AuthReferralsSettingsMatterTypesRoute: typeof AuthReferralsSettingsMatterTypesRoute;
  AuthReferralsSettingsProfileRoute: typeof AuthReferralsSettingsProfileRoute;
  AuthReferralsSettingsRolesRoute: typeof AuthReferralsSettingsRolesRoute;
  AuthReferralsSettingsStatusesRoute: typeof AuthReferralsSettingsStatusesRoute;
  AuthReferralsSettingsTagsRoute: typeof AuthReferralsSettingsTagsRoute;
  AuthReferralsSettingsTaskPlansRoute: typeof AuthReferralsSettingsTaskPlansRoute;
  AuthReferralsSettingsTeamsRoute: typeof AuthReferralsSettingsTeamsRoute;
}

const AuthReferralsSettingsRouteChildren: AuthReferralsSettingsRouteChildren = {
  AuthReferralsSettingsMatterTypesRoute: AuthReferralsSettingsMatterTypesRoute,
  AuthReferralsSettingsProfileRoute: AuthReferralsSettingsProfileRoute,
  AuthReferralsSettingsRolesRoute: AuthReferralsSettingsRolesRoute,
  AuthReferralsSettingsStatusesRoute: AuthReferralsSettingsStatusesRoute,
  AuthReferralsSettingsTagsRoute: AuthReferralsSettingsTagsRoute,
  AuthReferralsSettingsTaskPlansRoute: AuthReferralsSettingsTaskPlansRoute,
  AuthReferralsSettingsTeamsRoute: AuthReferralsSettingsTeamsRoute,
};

const AuthReferralsSettingsRouteWithChildren =
  AuthReferralsSettingsRoute._addFileChildren(
    AuthReferralsSettingsRouteChildren,
  );

interface AuthMassTortsMassTortSearchIdLayoutRouteChildren {
  AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute: typeof AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute;
  AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute: typeof AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute;
  AuthMassTortsMassTortSearchIdLayoutFilesRoute: typeof AuthMassTortsMassTortSearchIdLayoutFilesRoute;
  AuthMassTortsMassTortSearchIdLayoutNotesRoute: typeof AuthMassTortsMassTortSearchIdLayoutNotesRoute;
  AuthMassTortsMassTortSearchIdLayoutSurveysRoute: typeof AuthMassTortsMassTortSearchIdLayoutSurveysRoute;
  AuthMassTortsMassTortSearchIdLayoutTasksRoute: typeof AuthMassTortsMassTortSearchIdLayoutTasksRoute;
  AuthMassTortsMassTortSearchIdLayoutIndexRoute: typeof AuthMassTortsMassTortSearchIdLayoutIndexRoute;
}

const AuthMassTortsMassTortSearchIdLayoutRouteChildren: AuthMassTortsMassTortSearchIdLayoutRouteChildren =
  {
    AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute:
      AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute,
    AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute:
      AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute,
    AuthMassTortsMassTortSearchIdLayoutFilesRoute:
      AuthMassTortsMassTortSearchIdLayoutFilesRoute,
    AuthMassTortsMassTortSearchIdLayoutNotesRoute:
      AuthMassTortsMassTortSearchIdLayoutNotesRoute,
    AuthMassTortsMassTortSearchIdLayoutSurveysRoute:
      AuthMassTortsMassTortSearchIdLayoutSurveysRoute,
    AuthMassTortsMassTortSearchIdLayoutTasksRoute:
      AuthMassTortsMassTortSearchIdLayoutTasksRoute,
    AuthMassTortsMassTortSearchIdLayoutIndexRoute:
      AuthMassTortsMassTortSearchIdLayoutIndexRoute,
  };

const AuthMassTortsMassTortSearchIdLayoutRouteWithChildren =
  AuthMassTortsMassTortSearchIdLayoutRoute._addFileChildren(
    AuthMassTortsMassTortSearchIdLayoutRouteChildren,
  );

interface AuthMassTortsMassTortSearchIdRouteChildren {
  AuthMassTortsMassTortSearchIdLayoutRoute: typeof AuthMassTortsMassTortSearchIdLayoutRouteWithChildren;
}

const AuthMassTortsMassTortSearchIdRouteChildren: AuthMassTortsMassTortSearchIdRouteChildren =
  {
    AuthMassTortsMassTortSearchIdLayoutRoute:
      AuthMassTortsMassTortSearchIdLayoutRouteWithChildren,
  };

const AuthMassTortsMassTortSearchIdRouteWithChildren =
  AuthMassTortsMassTortSearchIdRoute._addFileChildren(
    AuthMassTortsMassTortSearchIdRouteChildren,
  );

interface AuthMattersMatterIdLayoutRouteChildren {
  AuthMattersMatterIdLayoutChargesRoute: typeof AuthMattersMatterIdLayoutChargesRoute;
  AuthMattersMatterIdLayoutCostsRoute: typeof AuthMattersMatterIdLayoutCostsRoute;
  AuthMattersMatterIdLayoutCustomFieldsRoute: typeof AuthMattersMatterIdLayoutCustomFieldsRoute;
  AuthMattersMatterIdLayoutEmailsRoute: typeof AuthMattersMatterIdLayoutEmailsRoute;
  AuthMattersMatterIdLayoutFilesRoute: typeof AuthMattersMatterIdLayoutFilesRoute;
  AuthMattersMatterIdLayoutIncidentDetailsRoute: typeof AuthMattersMatterIdLayoutIncidentDetailsRoute;
  AuthMattersMatterIdLayoutLiensRoute: typeof AuthMattersMatterIdLayoutLiensRoute;
  AuthMattersMatterIdLayoutLitigationRoute: typeof AuthMattersMatterIdLayoutLitigationRoute;
  AuthMattersMatterIdLayoutMedicalTreatmentsRoute: typeof AuthMattersMatterIdLayoutMedicalTreatmentsRoute;
  AuthMattersMatterIdLayoutNotesRoute: typeof AuthMattersMatterIdLayoutNotesRoute;
  AuthMattersMatterIdLayoutPropertyDamageRoute: typeof AuthMattersMatterIdLayoutPropertyDamageRoute;
  AuthMattersMatterIdLayoutSettlementsRoute: typeof AuthMattersMatterIdLayoutSettlementsRoute;
  AuthMattersMatterIdLayoutSignatureRequestsRoute: typeof AuthMattersMatterIdLayoutSignatureRequestsRoute;
  AuthMattersMatterIdLayoutTasksRoute: typeof AuthMattersMatterIdLayoutTasksRoute;
  AuthMattersMatterIdLayoutUpdatesRoute: typeof AuthMattersMatterIdLayoutUpdatesRoute;
  AuthMattersMatterIdLayoutIndexRoute: typeof AuthMattersMatterIdLayoutIndexRoute;
  AuthMattersMatterIdLayoutMatterDetailsTabRoute: typeof AuthMattersMatterIdLayoutMatterDetailsTabRoute;
}

const AuthMattersMatterIdLayoutRouteChildren: AuthMattersMatterIdLayoutRouteChildren =
  {
    AuthMattersMatterIdLayoutChargesRoute:
      AuthMattersMatterIdLayoutChargesRoute,
    AuthMattersMatterIdLayoutCostsRoute: AuthMattersMatterIdLayoutCostsRoute,
    AuthMattersMatterIdLayoutCustomFieldsRoute:
      AuthMattersMatterIdLayoutCustomFieldsRoute,
    AuthMattersMatterIdLayoutEmailsRoute: AuthMattersMatterIdLayoutEmailsRoute,
    AuthMattersMatterIdLayoutFilesRoute: AuthMattersMatterIdLayoutFilesRoute,
    AuthMattersMatterIdLayoutIncidentDetailsRoute:
      AuthMattersMatterIdLayoutIncidentDetailsRoute,
    AuthMattersMatterIdLayoutLiensRoute: AuthMattersMatterIdLayoutLiensRoute,
    AuthMattersMatterIdLayoutLitigationRoute:
      AuthMattersMatterIdLayoutLitigationRoute,
    AuthMattersMatterIdLayoutMedicalTreatmentsRoute:
      AuthMattersMatterIdLayoutMedicalTreatmentsRoute,
    AuthMattersMatterIdLayoutNotesRoute: AuthMattersMatterIdLayoutNotesRoute,
    AuthMattersMatterIdLayoutPropertyDamageRoute:
      AuthMattersMatterIdLayoutPropertyDamageRoute,
    AuthMattersMatterIdLayoutSettlementsRoute:
      AuthMattersMatterIdLayoutSettlementsRoute,
    AuthMattersMatterIdLayoutSignatureRequestsRoute:
      AuthMattersMatterIdLayoutSignatureRequestsRoute,
    AuthMattersMatterIdLayoutTasksRoute: AuthMattersMatterIdLayoutTasksRoute,
    AuthMattersMatterIdLayoutUpdatesRoute:
      AuthMattersMatterIdLayoutUpdatesRoute,
    AuthMattersMatterIdLayoutIndexRoute: AuthMattersMatterIdLayoutIndexRoute,
    AuthMattersMatterIdLayoutMatterDetailsTabRoute:
      AuthMattersMatterIdLayoutMatterDetailsTabRoute,
  };

const AuthMattersMatterIdLayoutRouteWithChildren =
  AuthMattersMatterIdLayoutRoute._addFileChildren(
    AuthMattersMatterIdLayoutRouteChildren,
  );

interface AuthMattersMatterIdRouteChildren {
  AuthMattersMatterIdLayoutRoute: typeof AuthMattersMatterIdLayoutRouteWithChildren;
}

const AuthMattersMatterIdRouteChildren: AuthMattersMatterIdRouteChildren = {
  AuthMattersMatterIdLayoutRoute: AuthMattersMatterIdLayoutRouteWithChildren,
};

const AuthMattersMatterIdRouteWithChildren =
  AuthMattersMatterIdRoute._addFileChildren(AuthMattersMatterIdRouteChildren);

interface AuthRouteChildren {
  AuthAiRoute: typeof AuthAiRoute;
  AuthAutomationsRoute: typeof AuthAutomationsRoute;
  AuthChargesRoute: typeof AuthChargesRoute;
  AuthFilesRoute: typeof AuthFilesRoute;
  AuthMailSortingRoute: typeof AuthMailSortingRoute;
  AuthReportsRoute: typeof AuthReportsRouteWithChildren;
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren;
  AuthSignatureRequestsRoute: typeof AuthSignatureRequestsRoute;
  AuthSkillsRoute: typeof AuthSkillsRoute;
  AuthIndexRoute: typeof AuthIndexRoute;
  AuthAppsAppLibraryRoute: typeof AuthAppsAppLibraryRoute;
  AuthAppsMyAppsRoute: typeof AuthAppsMyAppsRoute;
  AuthFileContentFileContentIdRoute: typeof AuthFileContentFileContentIdRoute;
  AuthFirmPartnerFirmsRoute: typeof AuthFirmPartnerFirmsRoute;
  AuthFirmReferralProfileRoute: typeof AuthFirmReferralProfileRoute;
  AuthMattersMyMattersRoute: typeof AuthMattersMyMattersRoute;
  AuthMattersSettingsRoute: typeof AuthMattersSettingsRouteWithChildren;
  AuthReferralsDirectoryRoute: typeof AuthReferralsDirectoryRoute;
  AuthReferralsDirectoryProfileRoute: typeof AuthReferralsDirectoryProfileRoute;
  AuthReferralsPartnerFirmsRoute: typeof AuthReferralsPartnerFirmsRoute;
  AuthReferralsSettingsRoute: typeof AuthReferralsSettingsRouteWithChildren;
  AuthAppsIndexRoute: typeof AuthAppsIndexRoute;
  AuthContactsIndexRoute: typeof AuthContactsIndexRoute;
  AuthLeadsIndexRoute: typeof AuthLeadsIndexRoute;
  AuthMassTortsIndexRoute: typeof AuthMassTortsIndexRoute;
  AuthMattersIndexRoute: typeof AuthMattersIndexRoute;
  AuthOpportunitiesIndexRoute: typeof AuthOpportunitiesIndexRoute;
  AuthProfileIndexRoute: typeof AuthProfileIndexRoute;
  AuthReferralsIndexRoute: typeof AuthReferralsIndexRoute;
  AuthMassTortsMassTortSearchIdRoute: typeof AuthMassTortsMassTortSearchIdRouteWithChildren;
  AuthMattersMatterIdRoute: typeof AuthMattersMatterIdRouteWithChildren;
  AuthContactsContactIdIndexRoute: typeof AuthContactsContactIdIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAiRoute: AuthAiRoute,
  AuthAutomationsRoute: AuthAutomationsRoute,
  AuthChargesRoute: AuthChargesRoute,
  AuthFilesRoute: AuthFilesRoute,
  AuthMailSortingRoute: AuthMailSortingRoute,
  AuthReportsRoute: AuthReportsRouteWithChildren,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthSignatureRequestsRoute: AuthSignatureRequestsRoute,
  AuthSkillsRoute: AuthSkillsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAppsAppLibraryRoute: AuthAppsAppLibraryRoute,
  AuthAppsMyAppsRoute: AuthAppsMyAppsRoute,
  AuthFileContentFileContentIdRoute: AuthFileContentFileContentIdRoute,
  AuthFirmPartnerFirmsRoute: AuthFirmPartnerFirmsRoute,
  AuthFirmReferralProfileRoute: AuthFirmReferralProfileRoute,
  AuthMattersMyMattersRoute: AuthMattersMyMattersRoute,
  AuthMattersSettingsRoute: AuthMattersSettingsRouteWithChildren,
  AuthReferralsDirectoryRoute: AuthReferralsDirectoryRoute,
  AuthReferralsDirectoryProfileRoute: AuthReferralsDirectoryProfileRoute,
  AuthReferralsPartnerFirmsRoute: AuthReferralsPartnerFirmsRoute,
  AuthReferralsSettingsRoute: AuthReferralsSettingsRouteWithChildren,
  AuthAppsIndexRoute: AuthAppsIndexRoute,
  AuthContactsIndexRoute: AuthContactsIndexRoute,
  AuthLeadsIndexRoute: AuthLeadsIndexRoute,
  AuthMassTortsIndexRoute: AuthMassTortsIndexRoute,
  AuthMattersIndexRoute: AuthMattersIndexRoute,
  AuthOpportunitiesIndexRoute: AuthOpportunitiesIndexRoute,
  AuthProfileIndexRoute: AuthProfileIndexRoute,
  AuthReferralsIndexRoute: AuthReferralsIndexRoute,
  AuthMassTortsMassTortSearchIdRoute:
    AuthMassTortsMassTortSearchIdRouteWithChildren,
  AuthMattersMatterIdRoute: AuthMattersMatterIdRouteWithChildren,
  AuthContactsContactIdIndexRoute: AuthContactsContactIdIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

export interface FileRoutesByFullPath {
  "": typeof AuthRouteWithChildren;
  "/change-password": typeof ChangePasswordRoute;
  "/file-share": typeof FileShareRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign": typeof SignRoute;
  "/ai": typeof AuthAiRoute;
  "/automations": typeof AuthAutomationsRoute;
  "/charges": typeof AuthChargesRoute;
  "/files": typeof AuthFilesRoute;
  "/mail-sorting": typeof AuthMailSortingRoute;
  "/reports": typeof AuthReportsRouteWithChildren;
  "/settings": typeof AuthSettingsRouteWithChildren;
  "/signature-requests": typeof AuthSignatureRequestsRoute;
  "/skills": typeof AuthSkillsRoute;
  "/": typeof AuthIndexRoute;
  "/onboarding": typeof OnboardingIndexRoute;
  "/apps/app-library": typeof AuthAppsAppLibraryRoute;
  "/apps/my-apps": typeof AuthAppsMyAppsRoute;
  "/file-content/$fileContentId": typeof AuthFileContentFileContentIdRoute;
  "/firm/partner-firms": typeof AuthFirmPartnerFirmsRoute;
  "/firm/referral-profile": typeof AuthFirmReferralProfileRoute;
  "/matters/my-matters": typeof AuthMattersMyMattersRoute;
  "/matters/settings": typeof AuthMattersSettingsRouteWithChildren;
  "/referrals/directory": typeof AuthReferralsDirectoryRoute;
  "/referrals/directory-profile": typeof AuthReferralsDirectoryProfileRoute;
  "/referrals/partner-firms": typeof AuthReferralsPartnerFirmsRoute;
  "/referrals/settings": typeof AuthReferralsSettingsRouteWithChildren;
  "/reports/approaching-statutes": typeof AuthReportsApproachingStatutesRoute;
  "/reports/attorney-summary": typeof AuthReportsAttorneySummaryRoute;
  "/reports/case-assignments": typeof AuthReportsCaseAssignmentsRoute;
  "/reports/closed-matters": typeof AuthReportsClosedMattersRoute;
  "/reports/demand-summary": typeof AuthReportsDemandSummaryRoute;
  "/reports/demands": typeof AuthReportsDemandsRoute;
  "/reports/matter-activity": typeof AuthReportsMatterActivityRoute;
  "/reports/matter-status-count": typeof AuthReportsMatterStatusCountRoute;
  "/reports/my-approaching-statutes": typeof AuthReportsMyApproachingStatutesRoute;
  "/reports/open-matters": typeof AuthReportsOpenMattersRoute;
  "/reports/record-requests": typeof AuthReportsRecordRequestsRoute;
  "/reports/role-assignments": typeof AuthReportsRoleAssignmentsRoute;
  "/reports/settlement-summary": typeof AuthReportsSettlementSummaryRoute;
  "/reports/settlements": typeof AuthReportsSettlementsRoute;
  "/reports/user-productivity": typeof AuthReportsUserProductivityRoute;
  "/settings/communication": typeof AuthSettingsCommunicationRoute;
  "/settings/contact": typeof AuthSettingsContactRoute;
  "/settings/files": typeof AuthSettingsFilesRoute;
  "/settings/firm": typeof AuthSettingsFirmRoute;
  "/settings/intake": typeof AuthSettingsIntakeRouteWithChildren;
  "/settings/matter-defaults": typeof AuthSettingsMatterDefaultsRoute;
  "/settings/matter-types": typeof AuthSettingsMatterTypesRoute;
  "/settings/templates": typeof AuthSettingsTemplatesRoute;
  "/settings/users": typeof AuthSettingsUsersRoute;
  "/apps": typeof AuthAppsIndexRoute;
  "/contacts": typeof AuthContactsIndexRoute;
  "/leads": typeof AuthLeadsIndexRoute;
  "/mass-torts": typeof AuthMassTortsIndexRoute;
  "/matters": typeof AuthMattersIndexRoute;
  "/opportunities": typeof AuthOpportunitiesIndexRoute;
  "/profile": typeof AuthProfileIndexRoute;
  "/referrals": typeof AuthReferralsIndexRoute;
  "/reports/": typeof AuthReportsIndexRoute;
  "/settings/": typeof AuthSettingsIndexRoute;
  "/mass-torts/$massTortSearchId": typeof AuthMassTortsMassTortSearchIdLayoutRouteWithChildren;
  "/matters/$matterId": typeof AuthMattersMatterIdLayoutRouteWithChildren;
  "/matters/settings/costs": typeof AuthMattersSettingsCostsRoute;
  "/matters/settings/files": typeof AuthMattersSettingsFilesRoute;
  "/matters/settings/intake-templates": typeof AuthMattersSettingsIntakeTemplatesRoute;
  "/matters/settings/litigation-plans": typeof AuthMattersSettingsLitigationPlansRoute;
  "/matters/settings/matter-types": typeof AuthMattersSettingsMatterTypesRoute;
  "/matters/settings/phase-projects": typeof AuthMattersSettingsPhaseProjectsRoute;
  "/matters/settings/roles": typeof AuthMattersSettingsRolesRoute;
  "/matters/settings/scheduled-messages": typeof AuthMattersSettingsScheduledMessagesRoute;
  "/matters/settings/statuses": typeof AuthMattersSettingsStatusesRoute;
  "/matters/settings/tags": typeof AuthMattersSettingsTagsRoute;
  "/matters/settings/task-plans": typeof AuthMattersSettingsTaskPlansRoute;
  "/matters/settings/teams": typeof AuthMattersSettingsTeamsRoute;
  "/referrals/settings/matter-types": typeof AuthReferralsSettingsMatterTypesRoute;
  "/referrals/settings/profile": typeof AuthReferralsSettingsProfileRoute;
  "/referrals/settings/roles": typeof AuthReferralsSettingsRolesRoute;
  "/referrals/settings/statuses": typeof AuthReferralsSettingsStatusesRoute;
  "/referrals/settings/tags": typeof AuthReferralsSettingsTagsRoute;
  "/referrals/settings/task-plans": typeof AuthReferralsSettingsTaskPlansRoute;
  "/referrals/settings/teams": typeof AuthReferralsSettingsTeamsRoute;
  "/settings/intake/lead-sources": typeof AuthSettingsIntakeLeadSourcesRoute;
  "/settings/intake/matter-types": typeof AuthSettingsIntakeMatterTypesRoute;
  "/settings/intake/roles": typeof AuthSettingsIntakeRolesRoute;
  "/settings/intake/statuses": typeof AuthSettingsIntakeStatusesRoute;
  "/settings/intake/tags": typeof AuthSettingsIntakeTagsRoute;
  "/settings/intake/task-plans": typeof AuthSettingsIntakeTaskPlansRoute;
  "/settings/intake/teams": typeof AuthSettingsIntakeTeamsRoute;
  "/contacts/$contactId": typeof AuthContactsContactIdIndexRoute;
  "/settings/intake/": typeof AuthSettingsIntakeIndexRoute;
  "/mass-torts/$massTortSearchId/custom-fields": typeof AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute;
  "/mass-torts/$massTortSearchId/file-generation": typeof AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute;
  "/mass-torts/$massTortSearchId/files": typeof AuthMassTortsMassTortSearchIdLayoutFilesRoute;
  "/mass-torts/$massTortSearchId/notes": typeof AuthMassTortsMassTortSearchIdLayoutNotesRoute;
  "/mass-torts/$massTortSearchId/surveys": typeof AuthMassTortsMassTortSearchIdLayoutSurveysRoute;
  "/mass-torts/$massTortSearchId/tasks": typeof AuthMassTortsMassTortSearchIdLayoutTasksRoute;
  "/matters/$matterId/charges": typeof AuthMattersMatterIdLayoutChargesRoute;
  "/matters/$matterId/costs": typeof AuthMattersMatterIdLayoutCostsRoute;
  "/matters/$matterId/custom-fields": typeof AuthMattersMatterIdLayoutCustomFieldsRoute;
  "/matters/$matterId/emails": typeof AuthMattersMatterIdLayoutEmailsRoute;
  "/matters/$matterId/files": typeof AuthMattersMatterIdLayoutFilesRoute;
  "/matters/$matterId/incident-details": typeof AuthMattersMatterIdLayoutIncidentDetailsRoute;
  "/matters/$matterId/liens": typeof AuthMattersMatterIdLayoutLiensRoute;
  "/matters/$matterId/litigation": typeof AuthMattersMatterIdLayoutLitigationRoute;
  "/matters/$matterId/medical-treatments": typeof AuthMattersMatterIdLayoutMedicalTreatmentsRoute;
  "/matters/$matterId/notes": typeof AuthMattersMatterIdLayoutNotesRoute;
  "/matters/$matterId/property-damage": typeof AuthMattersMatterIdLayoutPropertyDamageRoute;
  "/matters/$matterId/settlements": typeof AuthMattersMatterIdLayoutSettlementsRoute;
  "/matters/$matterId/signature-requests": typeof AuthMattersMatterIdLayoutSignatureRequestsRoute;
  "/matters/$matterId/tasks": typeof AuthMattersMatterIdLayoutTasksRoute;
  "/matters/$matterId/updates": typeof AuthMattersMatterIdLayoutUpdatesRoute;
  "/mass-torts/$massTortSearchId/": typeof AuthMassTortsMassTortSearchIdLayoutIndexRoute;
  "/matters/$matterId/": typeof AuthMattersMatterIdLayoutIndexRoute;
  "/matters/$matterId/matter-details/$tab": typeof AuthMattersMatterIdLayoutMatterDetailsTabRoute;
}

export interface FileRoutesByTo {
  "/change-password": typeof ChangePasswordRoute;
  "/file-share": typeof FileShareRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign": typeof SignRoute;
  "/ai": typeof AuthAiRoute;
  "/automations": typeof AuthAutomationsRoute;
  "/charges": typeof AuthChargesRoute;
  "/files": typeof AuthFilesRoute;
  "/mail-sorting": typeof AuthMailSortingRoute;
  "/signature-requests": typeof AuthSignatureRequestsRoute;
  "/skills": typeof AuthSkillsRoute;
  "/": typeof AuthIndexRoute;
  "/onboarding": typeof OnboardingIndexRoute;
  "/apps/app-library": typeof AuthAppsAppLibraryRoute;
  "/apps/my-apps": typeof AuthAppsMyAppsRoute;
  "/file-content/$fileContentId": typeof AuthFileContentFileContentIdRoute;
  "/firm/partner-firms": typeof AuthFirmPartnerFirmsRoute;
  "/firm/referral-profile": typeof AuthFirmReferralProfileRoute;
  "/matters/my-matters": typeof AuthMattersMyMattersRoute;
  "/matters/settings": typeof AuthMattersSettingsRouteWithChildren;
  "/referrals/directory": typeof AuthReferralsDirectoryRoute;
  "/referrals/directory-profile": typeof AuthReferralsDirectoryProfileRoute;
  "/referrals/partner-firms": typeof AuthReferralsPartnerFirmsRoute;
  "/referrals/settings": typeof AuthReferralsSettingsRouteWithChildren;
  "/reports/approaching-statutes": typeof AuthReportsApproachingStatutesRoute;
  "/reports/attorney-summary": typeof AuthReportsAttorneySummaryRoute;
  "/reports/case-assignments": typeof AuthReportsCaseAssignmentsRoute;
  "/reports/closed-matters": typeof AuthReportsClosedMattersRoute;
  "/reports/demand-summary": typeof AuthReportsDemandSummaryRoute;
  "/reports/demands": typeof AuthReportsDemandsRoute;
  "/reports/matter-activity": typeof AuthReportsMatterActivityRoute;
  "/reports/matter-status-count": typeof AuthReportsMatterStatusCountRoute;
  "/reports/my-approaching-statutes": typeof AuthReportsMyApproachingStatutesRoute;
  "/reports/open-matters": typeof AuthReportsOpenMattersRoute;
  "/reports/record-requests": typeof AuthReportsRecordRequestsRoute;
  "/reports/role-assignments": typeof AuthReportsRoleAssignmentsRoute;
  "/reports/settlement-summary": typeof AuthReportsSettlementSummaryRoute;
  "/reports/settlements": typeof AuthReportsSettlementsRoute;
  "/reports/user-productivity": typeof AuthReportsUserProductivityRoute;
  "/settings/communication": typeof AuthSettingsCommunicationRoute;
  "/settings/contact": typeof AuthSettingsContactRoute;
  "/settings/files": typeof AuthSettingsFilesRoute;
  "/settings/firm": typeof AuthSettingsFirmRoute;
  "/settings/matter-defaults": typeof AuthSettingsMatterDefaultsRoute;
  "/settings/matter-types": typeof AuthSettingsMatterTypesRoute;
  "/settings/templates": typeof AuthSettingsTemplatesRoute;
  "/settings/users": typeof AuthSettingsUsersRoute;
  "/apps": typeof AuthAppsIndexRoute;
  "/contacts": typeof AuthContactsIndexRoute;
  "/leads": typeof AuthLeadsIndexRoute;
  "/mass-torts": typeof AuthMassTortsIndexRoute;
  "/matters": typeof AuthMattersIndexRoute;
  "/opportunities": typeof AuthOpportunitiesIndexRoute;
  "/profile": typeof AuthProfileIndexRoute;
  "/referrals": typeof AuthReferralsIndexRoute;
  "/reports": typeof AuthReportsIndexRoute;
  "/settings": typeof AuthSettingsIndexRoute;
  "/mass-torts/$massTortSearchId": typeof AuthMassTortsMassTortSearchIdLayoutIndexRoute;
  "/matters/$matterId": typeof AuthMattersMatterIdLayoutIndexRoute;
  "/matters/settings/costs": typeof AuthMattersSettingsCostsRoute;
  "/matters/settings/files": typeof AuthMattersSettingsFilesRoute;
  "/matters/settings/intake-templates": typeof AuthMattersSettingsIntakeTemplatesRoute;
  "/matters/settings/litigation-plans": typeof AuthMattersSettingsLitigationPlansRoute;
  "/matters/settings/matter-types": typeof AuthMattersSettingsMatterTypesRoute;
  "/matters/settings/phase-projects": typeof AuthMattersSettingsPhaseProjectsRoute;
  "/matters/settings/roles": typeof AuthMattersSettingsRolesRoute;
  "/matters/settings/scheduled-messages": typeof AuthMattersSettingsScheduledMessagesRoute;
  "/matters/settings/statuses": typeof AuthMattersSettingsStatusesRoute;
  "/matters/settings/tags": typeof AuthMattersSettingsTagsRoute;
  "/matters/settings/task-plans": typeof AuthMattersSettingsTaskPlansRoute;
  "/matters/settings/teams": typeof AuthMattersSettingsTeamsRoute;
  "/referrals/settings/matter-types": typeof AuthReferralsSettingsMatterTypesRoute;
  "/referrals/settings/profile": typeof AuthReferralsSettingsProfileRoute;
  "/referrals/settings/roles": typeof AuthReferralsSettingsRolesRoute;
  "/referrals/settings/statuses": typeof AuthReferralsSettingsStatusesRoute;
  "/referrals/settings/tags": typeof AuthReferralsSettingsTagsRoute;
  "/referrals/settings/task-plans": typeof AuthReferralsSettingsTaskPlansRoute;
  "/referrals/settings/teams": typeof AuthReferralsSettingsTeamsRoute;
  "/settings/intake/lead-sources": typeof AuthSettingsIntakeLeadSourcesRoute;
  "/settings/intake/matter-types": typeof AuthSettingsIntakeMatterTypesRoute;
  "/settings/intake/roles": typeof AuthSettingsIntakeRolesRoute;
  "/settings/intake/statuses": typeof AuthSettingsIntakeStatusesRoute;
  "/settings/intake/tags": typeof AuthSettingsIntakeTagsRoute;
  "/settings/intake/task-plans": typeof AuthSettingsIntakeTaskPlansRoute;
  "/settings/intake/teams": typeof AuthSettingsIntakeTeamsRoute;
  "/contacts/$contactId": typeof AuthContactsContactIdIndexRoute;
  "/settings/intake": typeof AuthSettingsIntakeIndexRoute;
  "/mass-torts/$massTortSearchId/custom-fields": typeof AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute;
  "/mass-torts/$massTortSearchId/file-generation": typeof AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute;
  "/mass-torts/$massTortSearchId/files": typeof AuthMassTortsMassTortSearchIdLayoutFilesRoute;
  "/mass-torts/$massTortSearchId/notes": typeof AuthMassTortsMassTortSearchIdLayoutNotesRoute;
  "/mass-torts/$massTortSearchId/surveys": typeof AuthMassTortsMassTortSearchIdLayoutSurveysRoute;
  "/mass-torts/$massTortSearchId/tasks": typeof AuthMassTortsMassTortSearchIdLayoutTasksRoute;
  "/matters/$matterId/charges": typeof AuthMattersMatterIdLayoutChargesRoute;
  "/matters/$matterId/costs": typeof AuthMattersMatterIdLayoutCostsRoute;
  "/matters/$matterId/custom-fields": typeof AuthMattersMatterIdLayoutCustomFieldsRoute;
  "/matters/$matterId/emails": typeof AuthMattersMatterIdLayoutEmailsRoute;
  "/matters/$matterId/files": typeof AuthMattersMatterIdLayoutFilesRoute;
  "/matters/$matterId/incident-details": typeof AuthMattersMatterIdLayoutIncidentDetailsRoute;
  "/matters/$matterId/liens": typeof AuthMattersMatterIdLayoutLiensRoute;
  "/matters/$matterId/litigation": typeof AuthMattersMatterIdLayoutLitigationRoute;
  "/matters/$matterId/medical-treatments": typeof AuthMattersMatterIdLayoutMedicalTreatmentsRoute;
  "/matters/$matterId/notes": typeof AuthMattersMatterIdLayoutNotesRoute;
  "/matters/$matterId/property-damage": typeof AuthMattersMatterIdLayoutPropertyDamageRoute;
  "/matters/$matterId/settlements": typeof AuthMattersMatterIdLayoutSettlementsRoute;
  "/matters/$matterId/signature-requests": typeof AuthMattersMatterIdLayoutSignatureRequestsRoute;
  "/matters/$matterId/tasks": typeof AuthMattersMatterIdLayoutTasksRoute;
  "/matters/$matterId/updates": typeof AuthMattersMatterIdLayoutUpdatesRoute;
  "/matters/$matterId/matter-details/$tab": typeof AuthMattersMatterIdLayoutMatterDetailsTabRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/_auth": typeof AuthRouteWithChildren;
  "/change-password": typeof ChangePasswordRoute;
  "/file-share": typeof FileShareRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/login": typeof LoginRoute;
  "/register": typeof RegisterRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/sign": typeof SignRoute;
  "/_auth/ai": typeof AuthAiRoute;
  "/_auth/automations": typeof AuthAutomationsRoute;
  "/_auth/charges": typeof AuthChargesRoute;
  "/_auth/files": typeof AuthFilesRoute;
  "/_auth/mail-sorting": typeof AuthMailSortingRoute;
  "/_auth/reports": typeof AuthReportsRouteWithChildren;
  "/_auth/settings": typeof AuthSettingsRouteWithChildren;
  "/_auth/signature-requests": typeof AuthSignatureRequestsRoute;
  "/_auth/skills": typeof AuthSkillsRoute;
  "/_auth/": typeof AuthIndexRoute;
  "/onboarding/": typeof OnboardingIndexRoute;
  "/_auth/apps/app-library": typeof AuthAppsAppLibraryRoute;
  "/_auth/apps/my-apps": typeof AuthAppsMyAppsRoute;
  "/_auth/file-content/$fileContentId": typeof AuthFileContentFileContentIdRoute;
  "/_auth/firm/partner-firms": typeof AuthFirmPartnerFirmsRoute;
  "/_auth/firm/referral-profile": typeof AuthFirmReferralProfileRoute;
  "/_auth/matters/my-matters": typeof AuthMattersMyMattersRoute;
  "/_auth/matters/settings": typeof AuthMattersSettingsRouteWithChildren;
  "/_auth/referrals/directory": typeof AuthReferralsDirectoryRoute;
  "/_auth/referrals/directory-profile": typeof AuthReferralsDirectoryProfileRoute;
  "/_auth/referrals/partner-firms": typeof AuthReferralsPartnerFirmsRoute;
  "/_auth/referrals/settings": typeof AuthReferralsSettingsRouteWithChildren;
  "/_auth/reports/approaching-statutes": typeof AuthReportsApproachingStatutesRoute;
  "/_auth/reports/attorney-summary": typeof AuthReportsAttorneySummaryRoute;
  "/_auth/reports/case-assignments": typeof AuthReportsCaseAssignmentsRoute;
  "/_auth/reports/closed-matters": typeof AuthReportsClosedMattersRoute;
  "/_auth/reports/demand-summary": typeof AuthReportsDemandSummaryRoute;
  "/_auth/reports/demands": typeof AuthReportsDemandsRoute;
  "/_auth/reports/matter-activity": typeof AuthReportsMatterActivityRoute;
  "/_auth/reports/matter-status-count": typeof AuthReportsMatterStatusCountRoute;
  "/_auth/reports/my-approaching-statutes": typeof AuthReportsMyApproachingStatutesRoute;
  "/_auth/reports/open-matters": typeof AuthReportsOpenMattersRoute;
  "/_auth/reports/record-requests": typeof AuthReportsRecordRequestsRoute;
  "/_auth/reports/role-assignments": typeof AuthReportsRoleAssignmentsRoute;
  "/_auth/reports/settlement-summary": typeof AuthReportsSettlementSummaryRoute;
  "/_auth/reports/settlements": typeof AuthReportsSettlementsRoute;
  "/_auth/reports/user-productivity": typeof AuthReportsUserProductivityRoute;
  "/_auth/settings/communication": typeof AuthSettingsCommunicationRoute;
  "/_auth/settings/contact": typeof AuthSettingsContactRoute;
  "/_auth/settings/files": typeof AuthSettingsFilesRoute;
  "/_auth/settings/firm": typeof AuthSettingsFirmRoute;
  "/_auth/settings/intake": typeof AuthSettingsIntakeRouteWithChildren;
  "/_auth/settings/matter-defaults": typeof AuthSettingsMatterDefaultsRoute;
  "/_auth/settings/matter-types": typeof AuthSettingsMatterTypesRoute;
  "/_auth/settings/templates": typeof AuthSettingsTemplatesRoute;
  "/_auth/settings/users": typeof AuthSettingsUsersRoute;
  "/_auth/apps/": typeof AuthAppsIndexRoute;
  "/_auth/contacts/": typeof AuthContactsIndexRoute;
  "/_auth/leads/": typeof AuthLeadsIndexRoute;
  "/_auth/mass-torts/": typeof AuthMassTortsIndexRoute;
  "/_auth/matters/": typeof AuthMattersIndexRoute;
  "/_auth/opportunities/": typeof AuthOpportunitiesIndexRoute;
  "/_auth/profile/": typeof AuthProfileIndexRoute;
  "/_auth/referrals/": typeof AuthReferralsIndexRoute;
  "/_auth/reports/": typeof AuthReportsIndexRoute;
  "/_auth/settings/": typeof AuthSettingsIndexRoute;
  "/_auth/mass-torts/$massTortSearchId": typeof AuthMassTortsMassTortSearchIdRouteWithChildren;
  "/_auth/mass-torts/$massTortSearchId/_layout": typeof AuthMassTortsMassTortSearchIdLayoutRouteWithChildren;
  "/_auth/matters/$matterId": typeof AuthMattersMatterIdRouteWithChildren;
  "/_auth/matters/$matterId/_layout": typeof AuthMattersMatterIdLayoutRouteWithChildren;
  "/_auth/matters/settings/costs": typeof AuthMattersSettingsCostsRoute;
  "/_auth/matters/settings/files": typeof AuthMattersSettingsFilesRoute;
  "/_auth/matters/settings/intake-templates": typeof AuthMattersSettingsIntakeTemplatesRoute;
  "/_auth/matters/settings/litigation-plans": typeof AuthMattersSettingsLitigationPlansRoute;
  "/_auth/matters/settings/matter-types": typeof AuthMattersSettingsMatterTypesRoute;
  "/_auth/matters/settings/phase-projects": typeof AuthMattersSettingsPhaseProjectsRoute;
  "/_auth/matters/settings/roles": typeof AuthMattersSettingsRolesRoute;
  "/_auth/matters/settings/scheduled-messages": typeof AuthMattersSettingsScheduledMessagesRoute;
  "/_auth/matters/settings/statuses": typeof AuthMattersSettingsStatusesRoute;
  "/_auth/matters/settings/tags": typeof AuthMattersSettingsTagsRoute;
  "/_auth/matters/settings/task-plans": typeof AuthMattersSettingsTaskPlansRoute;
  "/_auth/matters/settings/teams": typeof AuthMattersSettingsTeamsRoute;
  "/_auth/referrals/settings/matter-types": typeof AuthReferralsSettingsMatterTypesRoute;
  "/_auth/referrals/settings/profile": typeof AuthReferralsSettingsProfileRoute;
  "/_auth/referrals/settings/roles": typeof AuthReferralsSettingsRolesRoute;
  "/_auth/referrals/settings/statuses": typeof AuthReferralsSettingsStatusesRoute;
  "/_auth/referrals/settings/tags": typeof AuthReferralsSettingsTagsRoute;
  "/_auth/referrals/settings/task-plans": typeof AuthReferralsSettingsTaskPlansRoute;
  "/_auth/referrals/settings/teams": typeof AuthReferralsSettingsTeamsRoute;
  "/_auth/settings/intake/lead-sources": typeof AuthSettingsIntakeLeadSourcesRoute;
  "/_auth/settings/intake/matter-types": typeof AuthSettingsIntakeMatterTypesRoute;
  "/_auth/settings/intake/roles": typeof AuthSettingsIntakeRolesRoute;
  "/_auth/settings/intake/statuses": typeof AuthSettingsIntakeStatusesRoute;
  "/_auth/settings/intake/tags": typeof AuthSettingsIntakeTagsRoute;
  "/_auth/settings/intake/task-plans": typeof AuthSettingsIntakeTaskPlansRoute;
  "/_auth/settings/intake/teams": typeof AuthSettingsIntakeTeamsRoute;
  "/_auth/contacts/$contactId/": typeof AuthContactsContactIdIndexRoute;
  "/_auth/settings/intake/": typeof AuthSettingsIntakeIndexRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields": typeof AuthMassTortsMassTortSearchIdLayoutCustomFieldsRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/file-generation": typeof AuthMassTortsMassTortSearchIdLayoutFileGenerationRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/files": typeof AuthMassTortsMassTortSearchIdLayoutFilesRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/notes": typeof AuthMassTortsMassTortSearchIdLayoutNotesRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/surveys": typeof AuthMassTortsMassTortSearchIdLayoutSurveysRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/tasks": typeof AuthMassTortsMassTortSearchIdLayoutTasksRoute;
  "/_auth/matters/$matterId/_layout/charges": typeof AuthMattersMatterIdLayoutChargesRoute;
  "/_auth/matters/$matterId/_layout/costs": typeof AuthMattersMatterIdLayoutCostsRoute;
  "/_auth/matters/$matterId/_layout/custom-fields": typeof AuthMattersMatterIdLayoutCustomFieldsRoute;
  "/_auth/matters/$matterId/_layout/emails": typeof AuthMattersMatterIdLayoutEmailsRoute;
  "/_auth/matters/$matterId/_layout/files": typeof AuthMattersMatterIdLayoutFilesRoute;
  "/_auth/matters/$matterId/_layout/incident-details": typeof AuthMattersMatterIdLayoutIncidentDetailsRoute;
  "/_auth/matters/$matterId/_layout/liens": typeof AuthMattersMatterIdLayoutLiensRoute;
  "/_auth/matters/$matterId/_layout/litigation": typeof AuthMattersMatterIdLayoutLitigationRoute;
  "/_auth/matters/$matterId/_layout/medical-treatments": typeof AuthMattersMatterIdLayoutMedicalTreatmentsRoute;
  "/_auth/matters/$matterId/_layout/notes": typeof AuthMattersMatterIdLayoutNotesRoute;
  "/_auth/matters/$matterId/_layout/property-damage": typeof AuthMattersMatterIdLayoutPropertyDamageRoute;
  "/_auth/matters/$matterId/_layout/settlements": typeof AuthMattersMatterIdLayoutSettlementsRoute;
  "/_auth/matters/$matterId/_layout/signature-requests": typeof AuthMattersMatterIdLayoutSignatureRequestsRoute;
  "/_auth/matters/$matterId/_layout/tasks": typeof AuthMattersMatterIdLayoutTasksRoute;
  "/_auth/matters/$matterId/_layout/updates": typeof AuthMattersMatterIdLayoutUpdatesRoute;
  "/_auth/mass-torts/$massTortSearchId/_layout/": typeof AuthMassTortsMassTortSearchIdLayoutIndexRoute;
  "/_auth/matters/$matterId/_layout/": typeof AuthMattersMatterIdLayoutIndexRoute;
  "/_auth/matters/$matterId/_layout/matter-details/$tab": typeof AuthMattersMatterIdLayoutMatterDetailsTabRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ""
    | "/change-password"
    | "/file-share"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/sign"
    | "/ai"
    | "/automations"
    | "/charges"
    | "/files"
    | "/mail-sorting"
    | "/reports"
    | "/settings"
    | "/signature-requests"
    | "/skills"
    | "/"
    | "/onboarding"
    | "/apps/app-library"
    | "/apps/my-apps"
    | "/file-content/$fileContentId"
    | "/firm/partner-firms"
    | "/firm/referral-profile"
    | "/matters/my-matters"
    | "/matters/settings"
    | "/referrals/directory"
    | "/referrals/directory-profile"
    | "/referrals/partner-firms"
    | "/referrals/settings"
    | "/reports/approaching-statutes"
    | "/reports/attorney-summary"
    | "/reports/case-assignments"
    | "/reports/closed-matters"
    | "/reports/demand-summary"
    | "/reports/demands"
    | "/reports/matter-activity"
    | "/reports/matter-status-count"
    | "/reports/my-approaching-statutes"
    | "/reports/open-matters"
    | "/reports/record-requests"
    | "/reports/role-assignments"
    | "/reports/settlement-summary"
    | "/reports/settlements"
    | "/reports/user-productivity"
    | "/settings/communication"
    | "/settings/contact"
    | "/settings/files"
    | "/settings/firm"
    | "/settings/intake"
    | "/settings/matter-defaults"
    | "/settings/matter-types"
    | "/settings/templates"
    | "/settings/users"
    | "/apps"
    | "/contacts"
    | "/leads"
    | "/mass-torts"
    | "/matters"
    | "/opportunities"
    | "/profile"
    | "/referrals"
    | "/reports/"
    | "/settings/"
    | "/mass-torts/$massTortSearchId"
    | "/matters/$matterId"
    | "/matters/settings/costs"
    | "/matters/settings/files"
    | "/matters/settings/intake-templates"
    | "/matters/settings/litigation-plans"
    | "/matters/settings/matter-types"
    | "/matters/settings/phase-projects"
    | "/matters/settings/roles"
    | "/matters/settings/scheduled-messages"
    | "/matters/settings/statuses"
    | "/matters/settings/tags"
    | "/matters/settings/task-plans"
    | "/matters/settings/teams"
    | "/referrals/settings/matter-types"
    | "/referrals/settings/profile"
    | "/referrals/settings/roles"
    | "/referrals/settings/statuses"
    | "/referrals/settings/tags"
    | "/referrals/settings/task-plans"
    | "/referrals/settings/teams"
    | "/settings/intake/lead-sources"
    | "/settings/intake/matter-types"
    | "/settings/intake/roles"
    | "/settings/intake/statuses"
    | "/settings/intake/tags"
    | "/settings/intake/task-plans"
    | "/settings/intake/teams"
    | "/contacts/$contactId"
    | "/settings/intake/"
    | "/mass-torts/$massTortSearchId/custom-fields"
    | "/mass-torts/$massTortSearchId/file-generation"
    | "/mass-torts/$massTortSearchId/files"
    | "/mass-torts/$massTortSearchId/notes"
    | "/mass-torts/$massTortSearchId/surveys"
    | "/mass-torts/$massTortSearchId/tasks"
    | "/matters/$matterId/charges"
    | "/matters/$matterId/costs"
    | "/matters/$matterId/custom-fields"
    | "/matters/$matterId/emails"
    | "/matters/$matterId/files"
    | "/matters/$matterId/incident-details"
    | "/matters/$matterId/liens"
    | "/matters/$matterId/litigation"
    | "/matters/$matterId/medical-treatments"
    | "/matters/$matterId/notes"
    | "/matters/$matterId/property-damage"
    | "/matters/$matterId/settlements"
    | "/matters/$matterId/signature-requests"
    | "/matters/$matterId/tasks"
    | "/matters/$matterId/updates"
    | "/mass-torts/$massTortSearchId/"
    | "/matters/$matterId/"
    | "/matters/$matterId/matter-details/$tab";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/change-password"
    | "/file-share"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/sign"
    | "/ai"
    | "/automations"
    | "/charges"
    | "/files"
    | "/mail-sorting"
    | "/signature-requests"
    | "/skills"
    | "/"
    | "/onboarding"
    | "/apps/app-library"
    | "/apps/my-apps"
    | "/file-content/$fileContentId"
    | "/firm/partner-firms"
    | "/firm/referral-profile"
    | "/matters/my-matters"
    | "/matters/settings"
    | "/referrals/directory"
    | "/referrals/directory-profile"
    | "/referrals/partner-firms"
    | "/referrals/settings"
    | "/reports/approaching-statutes"
    | "/reports/attorney-summary"
    | "/reports/case-assignments"
    | "/reports/closed-matters"
    | "/reports/demand-summary"
    | "/reports/demands"
    | "/reports/matter-activity"
    | "/reports/matter-status-count"
    | "/reports/my-approaching-statutes"
    | "/reports/open-matters"
    | "/reports/record-requests"
    | "/reports/role-assignments"
    | "/reports/settlement-summary"
    | "/reports/settlements"
    | "/reports/user-productivity"
    | "/settings/communication"
    | "/settings/contact"
    | "/settings/files"
    | "/settings/firm"
    | "/settings/matter-defaults"
    | "/settings/matter-types"
    | "/settings/templates"
    | "/settings/users"
    | "/apps"
    | "/contacts"
    | "/leads"
    | "/mass-torts"
    | "/matters"
    | "/opportunities"
    | "/profile"
    | "/referrals"
    | "/reports"
    | "/settings"
    | "/mass-torts/$massTortSearchId"
    | "/matters/$matterId"
    | "/matters/settings/costs"
    | "/matters/settings/files"
    | "/matters/settings/intake-templates"
    | "/matters/settings/litigation-plans"
    | "/matters/settings/matter-types"
    | "/matters/settings/phase-projects"
    | "/matters/settings/roles"
    | "/matters/settings/scheduled-messages"
    | "/matters/settings/statuses"
    | "/matters/settings/tags"
    | "/matters/settings/task-plans"
    | "/matters/settings/teams"
    | "/referrals/settings/matter-types"
    | "/referrals/settings/profile"
    | "/referrals/settings/roles"
    | "/referrals/settings/statuses"
    | "/referrals/settings/tags"
    | "/referrals/settings/task-plans"
    | "/referrals/settings/teams"
    | "/settings/intake/lead-sources"
    | "/settings/intake/matter-types"
    | "/settings/intake/roles"
    | "/settings/intake/statuses"
    | "/settings/intake/tags"
    | "/settings/intake/task-plans"
    | "/settings/intake/teams"
    | "/contacts/$contactId"
    | "/settings/intake"
    | "/mass-torts/$massTortSearchId/custom-fields"
    | "/mass-torts/$massTortSearchId/file-generation"
    | "/mass-torts/$massTortSearchId/files"
    | "/mass-torts/$massTortSearchId/notes"
    | "/mass-torts/$massTortSearchId/surveys"
    | "/mass-torts/$massTortSearchId/tasks"
    | "/matters/$matterId/charges"
    | "/matters/$matterId/costs"
    | "/matters/$matterId/custom-fields"
    | "/matters/$matterId/emails"
    | "/matters/$matterId/files"
    | "/matters/$matterId/incident-details"
    | "/matters/$matterId/liens"
    | "/matters/$matterId/litigation"
    | "/matters/$matterId/medical-treatments"
    | "/matters/$matterId/notes"
    | "/matters/$matterId/property-damage"
    | "/matters/$matterId/settlements"
    | "/matters/$matterId/signature-requests"
    | "/matters/$matterId/tasks"
    | "/matters/$matterId/updates"
    | "/matters/$matterId/matter-details/$tab";
  id:
    | "__root__"
    | "/_auth"
    | "/change-password"
    | "/file-share"
    | "/forgot-password"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/sign"
    | "/_auth/ai"
    | "/_auth/automations"
    | "/_auth/charges"
    | "/_auth/files"
    | "/_auth/mail-sorting"
    | "/_auth/reports"
    | "/_auth/settings"
    | "/_auth/signature-requests"
    | "/_auth/skills"
    | "/_auth/"
    | "/onboarding/"
    | "/_auth/apps/app-library"
    | "/_auth/apps/my-apps"
    | "/_auth/file-content/$fileContentId"
    | "/_auth/firm/partner-firms"
    | "/_auth/firm/referral-profile"
    | "/_auth/matters/my-matters"
    | "/_auth/matters/settings"
    | "/_auth/referrals/directory"
    | "/_auth/referrals/directory-profile"
    | "/_auth/referrals/partner-firms"
    | "/_auth/referrals/settings"
    | "/_auth/reports/approaching-statutes"
    | "/_auth/reports/attorney-summary"
    | "/_auth/reports/case-assignments"
    | "/_auth/reports/closed-matters"
    | "/_auth/reports/demand-summary"
    | "/_auth/reports/demands"
    | "/_auth/reports/matter-activity"
    | "/_auth/reports/matter-status-count"
    | "/_auth/reports/my-approaching-statutes"
    | "/_auth/reports/open-matters"
    | "/_auth/reports/record-requests"
    | "/_auth/reports/role-assignments"
    | "/_auth/reports/settlement-summary"
    | "/_auth/reports/settlements"
    | "/_auth/reports/user-productivity"
    | "/_auth/settings/communication"
    | "/_auth/settings/contact"
    | "/_auth/settings/files"
    | "/_auth/settings/firm"
    | "/_auth/settings/intake"
    | "/_auth/settings/matter-defaults"
    | "/_auth/settings/matter-types"
    | "/_auth/settings/templates"
    | "/_auth/settings/users"
    | "/_auth/apps/"
    | "/_auth/contacts/"
    | "/_auth/leads/"
    | "/_auth/mass-torts/"
    | "/_auth/matters/"
    | "/_auth/opportunities/"
    | "/_auth/profile/"
    | "/_auth/referrals/"
    | "/_auth/reports/"
    | "/_auth/settings/"
    | "/_auth/mass-torts/$massTortSearchId"
    | "/_auth/mass-torts/$massTortSearchId/_layout"
    | "/_auth/matters/$matterId"
    | "/_auth/matters/$matterId/_layout"
    | "/_auth/matters/settings/costs"
    | "/_auth/matters/settings/files"
    | "/_auth/matters/settings/intake-templates"
    | "/_auth/matters/settings/litigation-plans"
    | "/_auth/matters/settings/matter-types"
    | "/_auth/matters/settings/phase-projects"
    | "/_auth/matters/settings/roles"
    | "/_auth/matters/settings/scheduled-messages"
    | "/_auth/matters/settings/statuses"
    | "/_auth/matters/settings/tags"
    | "/_auth/matters/settings/task-plans"
    | "/_auth/matters/settings/teams"
    | "/_auth/referrals/settings/matter-types"
    | "/_auth/referrals/settings/profile"
    | "/_auth/referrals/settings/roles"
    | "/_auth/referrals/settings/statuses"
    | "/_auth/referrals/settings/tags"
    | "/_auth/referrals/settings/task-plans"
    | "/_auth/referrals/settings/teams"
    | "/_auth/settings/intake/lead-sources"
    | "/_auth/settings/intake/matter-types"
    | "/_auth/settings/intake/roles"
    | "/_auth/settings/intake/statuses"
    | "/_auth/settings/intake/tags"
    | "/_auth/settings/intake/task-plans"
    | "/_auth/settings/intake/teams"
    | "/_auth/contacts/$contactId/"
    | "/_auth/settings/intake/"
    | "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields"
    | "/_auth/mass-torts/$massTortSearchId/_layout/file-generation"
    | "/_auth/mass-torts/$massTortSearchId/_layout/files"
    | "/_auth/mass-torts/$massTortSearchId/_layout/notes"
    | "/_auth/mass-torts/$massTortSearchId/_layout/surveys"
    | "/_auth/mass-torts/$massTortSearchId/_layout/tasks"
    | "/_auth/matters/$matterId/_layout/charges"
    | "/_auth/matters/$matterId/_layout/costs"
    | "/_auth/matters/$matterId/_layout/custom-fields"
    | "/_auth/matters/$matterId/_layout/emails"
    | "/_auth/matters/$matterId/_layout/files"
    | "/_auth/matters/$matterId/_layout/incident-details"
    | "/_auth/matters/$matterId/_layout/liens"
    | "/_auth/matters/$matterId/_layout/litigation"
    | "/_auth/matters/$matterId/_layout/medical-treatments"
    | "/_auth/matters/$matterId/_layout/notes"
    | "/_auth/matters/$matterId/_layout/property-damage"
    | "/_auth/matters/$matterId/_layout/settlements"
    | "/_auth/matters/$matterId/_layout/signature-requests"
    | "/_auth/matters/$matterId/_layout/tasks"
    | "/_auth/matters/$matterId/_layout/updates"
    | "/_auth/mass-torts/$massTortSearchId/_layout/"
    | "/_auth/matters/$matterId/_layout/"
    | "/_auth/matters/$matterId/_layout/matter-details/$tab";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren;
  ChangePasswordRoute: typeof ChangePasswordRoute;
  FileShareRoute: typeof FileShareRoute;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LoginRoute: typeof LoginRoute;
  RegisterRoute: typeof RegisterRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  SignRoute: typeof SignRoute;
  OnboardingIndexRoute: typeof OnboardingIndexRoute;
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  FileShareRoute: FileShareRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignRoute: SignRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/change-password",
        "/file-share",
        "/forgot-password",
        "/login",
        "/register",
        "/reset-password",
        "/sign",
        "/onboarding/"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/ai",
        "/_auth/automations",
        "/_auth/charges",
        "/_auth/files",
        "/_auth/mail-sorting",
        "/_auth/reports",
        "/_auth/settings",
        "/_auth/signature-requests",
        "/_auth/skills",
        "/_auth/",
        "/_auth/apps/app-library",
        "/_auth/apps/my-apps",
        "/_auth/file-content/$fileContentId",
        "/_auth/firm/partner-firms",
        "/_auth/firm/referral-profile",
        "/_auth/matters/my-matters",
        "/_auth/matters/settings",
        "/_auth/referrals/directory",
        "/_auth/referrals/directory-profile",
        "/_auth/referrals/partner-firms",
        "/_auth/referrals/settings",
        "/_auth/apps/",
        "/_auth/contacts/",
        "/_auth/leads/",
        "/_auth/mass-torts/",
        "/_auth/matters/",
        "/_auth/opportunities/",
        "/_auth/profile/",
        "/_auth/referrals/",
        "/_auth/mass-torts/$massTortSearchId",
        "/_auth/matters/$matterId",
        "/_auth/contacts/$contactId/"
      ]
    },
    "/change-password": {
      "filePath": "change-password.tsx"
    },
    "/file-share": {
      "filePath": "file-share.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/sign": {
      "filePath": "sign.tsx"
    },
    "/_auth/ai": {
      "filePath": "_auth/ai.tsx",
      "parent": "/_auth"
    },
    "/_auth/automations": {
      "filePath": "_auth/automations.tsx",
      "parent": "/_auth"
    },
    "/_auth/charges": {
      "filePath": "_auth/charges.tsx",
      "parent": "/_auth"
    },
    "/_auth/files": {
      "filePath": "_auth/files.tsx",
      "parent": "/_auth"
    },
    "/_auth/mail-sorting": {
      "filePath": "_auth/mail-sorting.tsx",
      "parent": "/_auth"
    },
    "/_auth/reports": {
      "filePath": "_auth/reports.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/reports/approaching-statutes",
        "/_auth/reports/attorney-summary",
        "/_auth/reports/case-assignments",
        "/_auth/reports/closed-matters",
        "/_auth/reports/demand-summary",
        "/_auth/reports/demands",
        "/_auth/reports/matter-activity",
        "/_auth/reports/matter-status-count",
        "/_auth/reports/my-approaching-statutes",
        "/_auth/reports/open-matters",
        "/_auth/reports/record-requests",
        "/_auth/reports/role-assignments",
        "/_auth/reports/settlement-summary",
        "/_auth/reports/settlements",
        "/_auth/reports/user-productivity",
        "/_auth/reports/"
      ]
    },
    "/_auth/settings": {
      "filePath": "_auth/settings.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/settings/communication",
        "/_auth/settings/contact",
        "/_auth/settings/files",
        "/_auth/settings/firm",
        "/_auth/settings/intake",
        "/_auth/settings/matter-defaults",
        "/_auth/settings/matter-types",
        "/_auth/settings/templates",
        "/_auth/settings/users",
        "/_auth/settings/"
      ]
    },
    "/_auth/signature-requests": {
      "filePath": "_auth/signature-requests.tsx",
      "parent": "/_auth"
    },
    "/_auth/skills": {
      "filePath": "_auth/skills.tsx",
      "parent": "/_auth"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/onboarding/": {
      "filePath": "onboarding/index.tsx"
    },
    "/_auth/apps/app-library": {
      "filePath": "_auth/apps/app-library.tsx",
      "parent": "/_auth"
    },
    "/_auth/apps/my-apps": {
      "filePath": "_auth/apps/my-apps.tsx",
      "parent": "/_auth"
    },
    "/_auth/file-content/$fileContentId": {
      "filePath": "_auth/file-content.$fileContentId.tsx",
      "parent": "/_auth"
    },
    "/_auth/firm/partner-firms": {
      "filePath": "_auth/firm/partner-firms.tsx",
      "parent": "/_auth"
    },
    "/_auth/firm/referral-profile": {
      "filePath": "_auth/firm/referral-profile.tsx",
      "parent": "/_auth"
    },
    "/_auth/matters/my-matters": {
      "filePath": "_auth/matters/my-matters.tsx",
      "parent": "/_auth"
    },
    "/_auth/matters/settings": {
      "filePath": "_auth/matters/settings.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/matters/settings/costs",
        "/_auth/matters/settings/files",
        "/_auth/matters/settings/intake-templates",
        "/_auth/matters/settings/litigation-plans",
        "/_auth/matters/settings/matter-types",
        "/_auth/matters/settings/phase-projects",
        "/_auth/matters/settings/roles",
        "/_auth/matters/settings/scheduled-messages",
        "/_auth/matters/settings/statuses",
        "/_auth/matters/settings/tags",
        "/_auth/matters/settings/task-plans",
        "/_auth/matters/settings/teams"
      ]
    },
    "/_auth/referrals/directory": {
      "filePath": "_auth/referrals/directory.tsx",
      "parent": "/_auth"
    },
    "/_auth/referrals/directory-profile": {
      "filePath": "_auth/referrals/directory-profile.tsx",
      "parent": "/_auth"
    },
    "/_auth/referrals/partner-firms": {
      "filePath": "_auth/referrals/partner-firms.tsx",
      "parent": "/_auth"
    },
    "/_auth/referrals/settings": {
      "filePath": "_auth/referrals/settings.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/referrals/settings/matter-types",
        "/_auth/referrals/settings/profile",
        "/_auth/referrals/settings/roles",
        "/_auth/referrals/settings/statuses",
        "/_auth/referrals/settings/tags",
        "/_auth/referrals/settings/task-plans",
        "/_auth/referrals/settings/teams"
      ]
    },
    "/_auth/reports/approaching-statutes": {
      "filePath": "_auth/reports/approaching-statutes.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/attorney-summary": {
      "filePath": "_auth/reports/attorney-summary.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/case-assignments": {
      "filePath": "_auth/reports/case-assignments.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/closed-matters": {
      "filePath": "_auth/reports/closed-matters.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/demand-summary": {
      "filePath": "_auth/reports/demand-summary.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/demands": {
      "filePath": "_auth/reports/demands.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/matter-activity": {
      "filePath": "_auth/reports/matter-activity.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/matter-status-count": {
      "filePath": "_auth/reports/matter-status-count.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/my-approaching-statutes": {
      "filePath": "_auth/reports/my-approaching-statutes.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/open-matters": {
      "filePath": "_auth/reports/open-matters.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/record-requests": {
      "filePath": "_auth/reports/record-requests.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/role-assignments": {
      "filePath": "_auth/reports/role-assignments.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/settlement-summary": {
      "filePath": "_auth/reports/settlement-summary.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/settlements": {
      "filePath": "_auth/reports/settlements.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/reports/user-productivity": {
      "filePath": "_auth/reports/user-productivity.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/settings/communication": {
      "filePath": "_auth/settings/communication.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/contact": {
      "filePath": "_auth/settings/contact.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/files": {
      "filePath": "_auth/settings/files.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/firm": {
      "filePath": "_auth/settings/firm.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/intake": {
      "filePath": "_auth/settings/intake.tsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/intake/lead-sources",
        "/_auth/settings/intake/matter-types",
        "/_auth/settings/intake/roles",
        "/_auth/settings/intake/statuses",
        "/_auth/settings/intake/tags",
        "/_auth/settings/intake/task-plans",
        "/_auth/settings/intake/teams",
        "/_auth/settings/intake/"
      ]
    },
    "/_auth/settings/matter-defaults": {
      "filePath": "_auth/settings/matter-defaults.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/matter-types": {
      "filePath": "_auth/settings/matter-types.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/templates": {
      "filePath": "_auth/settings/templates.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/users": {
      "filePath": "_auth/settings/users.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/apps/": {
      "filePath": "_auth/apps/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/contacts/": {
      "filePath": "_auth/contacts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/leads/": {
      "filePath": "_auth/leads/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/mass-torts/": {
      "filePath": "_auth/mass-torts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/matters/": {
      "filePath": "_auth/matters/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/opportunities/": {
      "filePath": "_auth/opportunities/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/profile/": {
      "filePath": "_auth/profile/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/referrals/": {
      "filePath": "_auth/referrals/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/reports/": {
      "filePath": "_auth/reports/index.tsx",
      "parent": "/_auth/reports"
    },
    "/_auth/settings/": {
      "filePath": "_auth/settings/index.tsx",
      "parent": "/_auth/settings"
    },
    "/_auth/mass-torts/$massTortSearchId": {
      "filePath": "_auth/mass-torts/$massTortSearchId",
      "parent": "/_auth",
      "children": [
        "/_auth/mass-torts/$massTortSearchId/_layout"
      ]
    },
    "/_auth/mass-torts/$massTortSearchId/_layout": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId",
      "children": [
        "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields",
        "/_auth/mass-torts/$massTortSearchId/_layout/file-generation",
        "/_auth/mass-torts/$massTortSearchId/_layout/files",
        "/_auth/mass-torts/$massTortSearchId/_layout/notes",
        "/_auth/mass-torts/$massTortSearchId/_layout/surveys",
        "/_auth/mass-torts/$massTortSearchId/_layout/tasks",
        "/_auth/mass-torts/$massTortSearchId/_layout/"
      ]
    },
    "/_auth/matters/$matterId": {
      "filePath": "_auth/matters/$matterId",
      "parent": "/_auth",
      "children": [
        "/_auth/matters/$matterId/_layout"
      ]
    },
    "/_auth/matters/$matterId/_layout": {
      "filePath": "_auth/matters/$matterId/_layout.tsx",
      "parent": "/_auth/matters/$matterId",
      "children": [
        "/_auth/matters/$matterId/_layout/charges",
        "/_auth/matters/$matterId/_layout/costs",
        "/_auth/matters/$matterId/_layout/custom-fields",
        "/_auth/matters/$matterId/_layout/emails",
        "/_auth/matters/$matterId/_layout/files",
        "/_auth/matters/$matterId/_layout/incident-details",
        "/_auth/matters/$matterId/_layout/liens",
        "/_auth/matters/$matterId/_layout/litigation",
        "/_auth/matters/$matterId/_layout/medical-treatments",
        "/_auth/matters/$matterId/_layout/notes",
        "/_auth/matters/$matterId/_layout/property-damage",
        "/_auth/matters/$matterId/_layout/settlements",
        "/_auth/matters/$matterId/_layout/signature-requests",
        "/_auth/matters/$matterId/_layout/tasks",
        "/_auth/matters/$matterId/_layout/updates",
        "/_auth/matters/$matterId/_layout/",
        "/_auth/matters/$matterId/_layout/matter-details/$tab"
      ]
    },
    "/_auth/matters/settings/costs": {
      "filePath": "_auth/matters/settings/costs.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/files": {
      "filePath": "_auth/matters/settings/files.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/intake-templates": {
      "filePath": "_auth/matters/settings/intake-templates.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/litigation-plans": {
      "filePath": "_auth/matters/settings/litigation-plans.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/matter-types": {
      "filePath": "_auth/matters/settings/matter-types.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/phase-projects": {
      "filePath": "_auth/matters/settings/phase-projects.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/roles": {
      "filePath": "_auth/matters/settings/roles.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/scheduled-messages": {
      "filePath": "_auth/matters/settings/scheduled-messages.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/statuses": {
      "filePath": "_auth/matters/settings/statuses.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/tags": {
      "filePath": "_auth/matters/settings/tags.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/task-plans": {
      "filePath": "_auth/matters/settings/task-plans.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/matters/settings/teams": {
      "filePath": "_auth/matters/settings/teams.tsx",
      "parent": "/_auth/matters/settings"
    },
    "/_auth/referrals/settings/matter-types": {
      "filePath": "_auth/referrals/settings/matter-types.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/profile": {
      "filePath": "_auth/referrals/settings/profile.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/roles": {
      "filePath": "_auth/referrals/settings/roles.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/statuses": {
      "filePath": "_auth/referrals/settings/statuses.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/tags": {
      "filePath": "_auth/referrals/settings/tags.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/task-plans": {
      "filePath": "_auth/referrals/settings/task-plans.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/referrals/settings/teams": {
      "filePath": "_auth/referrals/settings/teams.tsx",
      "parent": "/_auth/referrals/settings"
    },
    "/_auth/settings/intake/lead-sources": {
      "filePath": "_auth/settings/intake/lead-sources.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/matter-types": {
      "filePath": "_auth/settings/intake/matter-types.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/roles": {
      "filePath": "_auth/settings/intake/roles.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/statuses": {
      "filePath": "_auth/settings/intake/statuses.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/tags": {
      "filePath": "_auth/settings/intake/tags.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/task-plans": {
      "filePath": "_auth/settings/intake/task-plans.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/settings/intake/teams": {
      "filePath": "_auth/settings/intake/teams.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/contacts/$contactId/": {
      "filePath": "_auth/contacts/$contactId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings/intake/": {
      "filePath": "_auth/settings/intake/index.tsx",
      "parent": "/_auth/settings/intake"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/custom-fields": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/custom-fields.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/file-generation": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/file-generation.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/files": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/files.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/notes": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/notes.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/surveys": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/surveys.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/tasks": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/tasks.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/matters/$matterId/_layout/charges": {
      "filePath": "_auth/matters/$matterId/_layout/charges.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/costs": {
      "filePath": "_auth/matters/$matterId/_layout/costs.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/custom-fields": {
      "filePath": "_auth/matters/$matterId/_layout/custom-fields.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/emails": {
      "filePath": "_auth/matters/$matterId/_layout/emails.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/files": {
      "filePath": "_auth/matters/$matterId/_layout/files.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/incident-details": {
      "filePath": "_auth/matters/$matterId/_layout/incident-details.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/liens": {
      "filePath": "_auth/matters/$matterId/_layout/liens.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/litigation": {
      "filePath": "_auth/matters/$matterId/_layout/litigation.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/medical-treatments": {
      "filePath": "_auth/matters/$matterId/_layout/medical-treatments.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/notes": {
      "filePath": "_auth/matters/$matterId/_layout/notes.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/property-damage": {
      "filePath": "_auth/matters/$matterId/_layout/property-damage.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/settlements": {
      "filePath": "_auth/matters/$matterId/_layout/settlements.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/signature-requests": {
      "filePath": "_auth/matters/$matterId/_layout/signature-requests.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/tasks": {
      "filePath": "_auth/matters/$matterId/_layout/tasks.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/updates": {
      "filePath": "_auth/matters/$matterId/_layout/updates.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/mass-torts/$massTortSearchId/_layout/": {
      "filePath": "_auth/mass-torts/$massTortSearchId/_layout/index.tsx",
      "parent": "/_auth/mass-torts/$massTortSearchId/_layout"
    },
    "/_auth/matters/$matterId/_layout/": {
      "filePath": "_auth/matters/$matterId/_layout/index.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    },
    "/_auth/matters/$matterId/_layout/matter-details/$tab": {
      "filePath": "_auth/matters/$matterId/_layout/matter-details/$tab.tsx",
      "parent": "/_auth/matters/$matterId/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
